"use strict";

function _typeof24(o) { "@babel/helpers - typeof"; return _typeof24 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof24(o); }
(function () {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __esm = function __esm(fn, res) {
    return function __init() {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
  };
  var __export = function __export(target, all) {
    for (var name in all) __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  };
  var __copyProps = function __copyProps(to, from, except, desc) {
    if (from && _typeof24(from) === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
        get: function (k) {
          return from[k];
        }.bind(null, key),
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
      });
    }
    return to;
  };
  var __toCommonJS = function __toCommonJS(mod) {
    return __copyProps(__defProp({}, "__esModule", {
      value: true
    }), mod);
  };

  // node_modules/js-cookie/dist/js.cookie.mjs
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target;
  }
  function init(converter, defaultAttributes) {
    function set(name, value, attributes) {
      if (typeof document === "undefined") {
        return;
      }
      attributes = assign({}, defaultAttributes, attributes);
      if (typeof attributes.expires === "number") {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }
      name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var stringifiedAttributes = "";
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue;
        }
        stringifiedAttributes += "; " + attributeName;
        if (attributes[attributeName] === true) {
          continue;
        }
        stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
      }
      return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
      if (typeof document === "undefined" || arguments.length && !name) {
        return;
      }
      var cookies = document.cookie ? document.cookie.split("; ") : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split("=");
        var value = parts.slice(1).join("=");
        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);
          if (name === found) {
            break;
          }
        } catch (e) {}
      }
      return name ? jar[name] : jar;
    }
    return Object.create({
      set: set,
      get: get,
      remove: function remove(name, attributes) {
        set(name, "", assign({}, attributes, {
          expires: -1
        }));
      },
      withAttributes: function withAttributes(attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function withConverter(converter2) {
        return init(assign({}, this.converter, converter2), this.attributes);
      }
    }, {
      attributes: {
        value: Object.freeze(defaultAttributes)
      },
      converter: {
        value: Object.freeze(converter)
      }
    });
  }
  var defaultConverter, api;
  var init_js_cookie = __esm({
    "node_modules/js-cookie/dist/js.cookie.mjs": function node_modules_jsCookie_dist_jsCookieMjs() {
      defaultConverter = {
        read: function read(value) {
          if (value[0] === '"') {
            value = value.slice(1, -1);
          }
          return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
          return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
      };
      api = init(defaultConverter, {
        path: "/"
      });
    }
  });

  // lib/constants/error-code.enum.js
  var error_code_enum_default;
  var init_error_code_enum = __esm({
    "lib/constants/error-code.enum.js": function lib_constants_errorCodeEnumJs() {
      "use strict";

      error_code_enum_default = {
        GAME_AUTH: {
          API: {
            FETCH_FAIL: {
              code: 117450,
              name: "API_FAILED"
            },
            RESPONSE_FAIL: {
              code: 117440,
              name: "RESPONSE_FAILED"
            },
            RESPONSE_EXCEPTION: {
              code: 117451,
              name: "RESPONSE_EXCEPTION"
            }
          },
          NONE_OF_BUSINESS: {
            code: 117500,
            name: "NONE_OF_BUSINESS"
            // SDK 가 핸들링하지 않은 에러입니다.
          },
          // Game Auth SDK 내부 에러
          SDK: {
            CAN_NOT_SAVE_GAME_TOKEN: {
              code: 117601,
              name: "CAN_NOT_SAVE_GAME_TOKEN"
            },
            INVALID_PARAMETER: {
              code: 117602,
              name: "INVALID_PARAMETER"
            },
            GAME_TOKEN_EXPIRED: {
              code: 117603,
              name: "GAME_TOKEN_EXPIRED"
            },
            GAME_TOKEN_VERIFICATION_FAILED: {
              code: 117604,
              name: "GAME_TOKEN_VERIFICATION_FAILED"
            },
            INVALID_GAME_TOKEN: {
              code: 117605,
              name: "INVALID_GAME_TOKEN"
            }
          }
        }
      };
    }
  });

  // lib/utils/converter.js
  function _regeneratorRuntime() {
    "use strict";

    _regeneratorRuntime = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = true,
        _d = false;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = false;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = true);
      } catch (err) {
        _d = true, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof(obj);
  }
  var camelToSnake, snakeToCamel, snakeToCamelForObject, camelToSnakeForObject, encrypt, decrypt, hmacSha256;
  var init_converter = __esm({
    "lib/utils/converter.js": function lib_utils_converterJs() {
      "use strict";

      camelToSnake = function camelToSnake2(str) {
        return (typeof str === "string" ? str : "").replace(/[A-Z]/g, function (s) {
          return "_".concat(s.toLowerCase());
        });
      };
      snakeToCamel = function snakeToCamel2(str) {
        return (typeof str === "string" ? str : "").toLocaleLowerCase().replace(/([-_][a-z])/g, function (group) {
          return group.toUpperCase().replace("-", "").replace("_", "");
        });
      };
      snakeToCamelForObject = function snakeToCamelForObject2(object) {
        return Object.entries(_typeof(object) === "object" ? object : {}).reduce(function (obj, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          obj[snakeToCamel(key)] = value;
          return obj;
        }, {});
      };
      camelToSnakeForObject = function camelToSnakeForObject2(object) {
        return Object.entries(_typeof(object) === "object" ? object : {}).reduce(function (obj, _ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          obj[camelToSnake(key)] = value;
          return obj;
        }, {});
      };
      encrypt = function encrypt2(plainText) {
        return window.btoa(plainText);
      };
      decrypt = function decrypt2(cipherText) {
        return window.atob(cipherText);
      };
      hmacSha256 = /* @__PURE__ */function () {
        var _ref5 = _asyncToGenerator( /* @__PURE__ */_regeneratorRuntime().mark(function _callee(plainText, secret) {
          var enc, algorithm, key, signature;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                enc = new TextEncoder("utf-8");
                algorithm = {
                  name: "HMAC",
                  hash: "SHA-256"
                };
                _context.next = 4;
                return crypto.subtle.importKey("raw", enc.encode(secret), algorithm, false, ["sign", "verify"]);
              case 4:
                key = _context.sent;
                _context.next = 7;
                return crypto.subtle.sign(algorithm.name, key, enc.encode(plainText));
              case 7:
                signature = _context.sent;
                return _context.abrupt("return", btoa(String.fromCharCode.apply(String, _toConsumableArray(new Uint8Array(signature)))));
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function hmacSha2562(_x2, _x3) {
          return _ref5.apply(this, arguments);
        };
      }();
    }
  });

  // lib/constants/env-variable.enum.js
  var ENV_VARIABLES;
  var init_env_variable_enum = __esm({
    "lib/constants/env-variable.enum.js": function lib_constants_envVariableEnumJs() {
      "use strict";

      init_converter();
      ENV_VARIABLES = {
        // local
        lo: {
          // IAC_API_URL: '/proxy-iac-api',
          // IAS_API_URL: '/proxy-ias-api',
          // IMS_API_URL: '/proxy-ims-api',
          // TOY_API_URL: '/proxy-sdk-api',
          // IAL_API_URL: '/proxy-ial-api',
          // IIV_API_URL: '/proxy-iiv-api',
          // BOLT_API_URL: '/proxy-bolt-api',
          // MEMBER_API_URL: '/proxy-member-api',
          INSIGN_BASE_URL: decrypt("aHR0cHM6Ly9sb2NhbC1zaWduaW4ubmV4b24uY29t"),
          // https://local-signin.nexon.com
          IAC_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYWMvdjE="),
          // https://dev-signin.nexon.com/iac/v1
          IAS_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYXM="),
          // https://dev-signin.nexon.com/ias
          IMS_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pbXMvdjE="),
          // https://dev-signin.nexon.com/ims/v1
          TOY_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9zZGstYXBp"),
          // https://dev-signin.nexon.com/sdk-api
          IAL_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYWwvdjE="),
          // https://dev-signin.nexon.com/ial/v1
          IIV_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9paXY="),
          // https://dev-signin.nexon.com/iiv
          BOLT_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS90b3kvYWxwaGE="),
          // https://dev-signin.nexon.com/toy/alpha
          MEMBER_API_URL: decrypt("aHR0cHM6Ly9tZW1iZXItdGVzdC5uZXhvbi5jb20=")
          // https://member-test.nexon.com
        },
        // dev
        de: {
          INSIGN_BASE_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbQ=="),
          // https://dev-signin.nexon.com
          IAC_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYWMvdjE="),
          // https://dev-signin.nexon.com/iac/v1
          IAS_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYXM="),
          // https://dev-signin.nexon.com/ias
          IMS_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pbXMvdjE="),
          // https://dev-signin.nexon.com/ims/v1
          TOY_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9zZGstYXBp"),
          // https://dev-signin.nexon.com/sdk-api
          IAL_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9pYWwvdjE="),
          // https://dev-signin.nexon.com/ial/v1
          IIV_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS9paXY="),
          // https://dev-signin.nexon.com/iiv
          BOLT_API_URL: decrypt("aHR0cHM6Ly9kZXYtc2lnbmluLm5leG9uLmNvbS90b3kvYWxwaGE="),
          // https://dev-signin.nexon.com/toy/alpha
          MEMBER_API_URL: decrypt("aHR0cHM6Ly9tZW1iZXItdGVzdC5uZXhvbi5jb20=")
          // https://member-test.nexon.com
        },
        // test
        te: {
          INSIGN_BASE_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20="),
          // https://test-signin.nexon.com
          IAC_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vaWFjL3B1YmxpYy92MQ=="),
          // https://test-signin.nexon.com/iac/public/v1
          IAS_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vaWFz"),
          // https://test-signin.nexon.com/ias
          IMS_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vaW1zL3B1YmxpYy92MQ=="),
          // https://test-signin.nexon.com/ims/public/v1
          TOY_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vc2RrLWFwaQ=="),
          // https://test-signin.nexon.com/sdk-api
          IAL_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vaWFsL3Yx"),
          // https://test-signin.nexon.com/ial/v1
          IIV_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vaWl2"),
          // https://test-signin.nexon.com/iiv
          BOLT_API_URL: decrypt("aHR0cHM6Ly90ZXN0LXNpZ25pbi5uZXhvbi5jb20vdG95"),
          // https://test-signin.nexon.com/toy
          MEMBER_API_URL: decrypt("aHR0cHM6Ly9tZW1iZXItdGVzdC5uZXhvbi5jb20=")
          // https://member-test.nexon.com
        },
        // pre
        pr: {
          INSIGN_BASE_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbQ=="),
          // https://pre-signin.nexon.com
          IAC_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9pYWMvcHJlL3Yx"),
          // https://pre-signin.nexon.com/iac/pre/v1
          IAS_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9pYXMvcHJl"),
          // https://pre-signin.nexon.com/ias/pre
          IMS_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9pbXMvcHJlL3Yx"),
          // https://pre-signin.nexon.com/ims/pre/v1
          TOY_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9zZGstYXBpL3ByZQ=="),
          // https://pre-signin.nexon.com/sdk-api/pre
          IAL_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9pYWwvcHJlL3Yx"),
          // https://pre-signin.nexon.com/ial/pre/v1
          IIV_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS9paXYvcHJl"),
          // https://pre-signin.nexon.com/iiv/pre
          BOLT_API_URL: decrypt("aHR0cHM6Ly9wcmUtc2lnbmluLm5leG9uLmNvbS90b3kvcHJl"),
          // https://pre-signin.nexon.com/toy/pre
          MEMBER_API_URL: decrypt("aHR0cHM6Ly9tZW1iZXIubmV4b24uY29t")
          // https://member.nexon.com
        },
        // live
        li: {
          INSIGN_BASE_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29t"),
          // https://signin.nexon.com
          IAC_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL2lhYy92MQ=="),
          // https://signin.nexon.com/iac/v1
          IAS_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL2lhcw=="),
          // https://signin.nexon.com/ias
          IMS_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL2ltcy92MQ=="),
          // https://signin.nexon.com/ims/v1
          TOY_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL3Nkay1hcGk="),
          // https://signin.nexon.com/sdk-api
          IAL_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL2lhbC92MQ=="),
          // https://signin.nexon.com/ial/v1
          IIV_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL2lpdg=="),
          // https://signin.nexon.com/iiv
          BOLT_API_URL: decrypt("aHR0cHM6Ly9zaWduaW4ubmV4b24uY29tL3RveQ=="),
          // https://signin.nexon.com/toy
          MEMBER_API_URL: decrypt("aHR0cHM6Ly9tZW1iZXIubmV4b24uY29t")
          // https://member.nexon.com
        }
      };
    }
  });

  // lib/constants/store.enum.js
  var COOKIE, SDK_COOKIE, DOMAIN, LOCAL_STORAGE;
  var init_store_enum = __esm({
    "lib/constants/store.enum.js": function lib_constants_storeEnumJs() {
      "use strict";

      COOKIE = {
        WEB_TOKEN: "_ifwt",
        GAME_TOKEN: "_ifgt",
        INSIGN_GW: "_ifinsign",
        INSIGN_PHASE: "_ifinsign_phase",
        GAME_AUTH_SDK: "_if_game_auth",
        SELECTOR_PLATFORM: "_ifplatform_selector"
      };
      SDK_COOKIE = {
        TEMP_OPTION: {
          MOVE_TO_LS: "move_to_ls",
          REMOVE_FROM_LS: "remove_from_ls"
        },
        UUID: "uuid"
      };
      DOMAIN = {
        NEXON: "nexon.com"
      };
      LOCAL_STORAGE = {
        PLAYNOW: {
          LOCAL_CREDENTIAL: "_ifinsign_front.pn.local_credential"
        },
        TOY_WEB_SDK: {
          UUID: "_ifinsign_front.toy_web_sdk.uuid"
        }
      };
    }
  });

  // lib/constants/constant-util.js
  var getEnvVariables;
  var init_constant_util = __esm({
    "lib/constants/constant-util.js": function lib_constants_constantUtilJs() {
      "use strict";

      init_env_variable_enum();
      getEnvVariables = function getEnvVariables2() {
        var insignEnv = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var env = insignEnv.substring(0, 2);
        return ENV_VARIABLES[env] || ENV_VARIABLES.li;
      };
    }
  });

  // lib/constants/event.enum.js
  var SDK_EVENT_TYPE, AUTH_USER_STATUS;
  var init_event_enum = __esm({
    "lib/constants/event.enum.js": function lib_constants_eventEnumJs() {
      "use strict";

      SDK_EVENT_TYPE = {
        UUID: "uuid",
        GAME_TOKEN: "gameToken",
        AUTH_SESSION: "auth:session",
        AUTH_USER: "auth:user"
      };
      AUTH_USER_STATUS = {
        LOGIN: "login",
        LOGOUT: "logout"
      };
    }
  });

  // lib/constants/domain.enum.js
  var PLATFORM, NEXON_HOME;
  var init_domain_enum = __esm({
    "lib/constants/domain.enum.js": function lib_constants_domainEnumJs() {
      "use strict";

      PLATFORM = {
        KRPC: "krpc",
        JPPC: "jppc",
        ARENA: "arena"
      };
      NEXON_HOME = {
        KRPC: "https://nexon.com",
        JPPC: "https://jp.nexon.com",
        ARENA: "https://www.nexon.com/main/en"
      };
    }
  });

  // lib/constants/index.js
  var ACCOUNT_TYPE;
  var init_constants = __esm({
    "lib/constants/index.js": function lib_constants_indexJs() {
      "use strict";

      init_error_code_enum();
      init_env_variable_enum();
      init_store_enum();
      init_constant_util();
      init_event_enum();
      init_domain_enum();
      ACCOUNT_TYPE = {
        PLAYNOW: "playnow",
        NX: "nx"
      };
    }
  });

  // lib/utils/index.js
  var init_utils = __esm({
    "lib/utils/index.js": function lib_utils_indexJs() {
      "use strict";

      init_converter();
    }
  });

  // lib/managers/store-manager.js
  function _typeof2(obj) {
    "@babel/helpers - typeof";

    return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof2(obj);
  }
  function _classCallCheck(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof2(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof2(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof2(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var STORE_MANAGER_INDEX, StoreManager, storeManager;
  var init_store_manager = __esm({
    "lib/managers/store-manager.js": function lib_managers_storeManagerJs() {
      "use strict";

      init_js_cookie();
      init_constants();
      init_utils();
      STORE_MANAGER_INDEX = {
        GUID: 0,
        GAME_TOKEN: 1
      };
      StoreManager = /* @__PURE__ */function () {
        function StoreManager2() {
          _classCallCheck(this, StoreManager2);
        }
        _createClass(StoreManager2, [{
          key: "webToken",
          get: function get() {
            return api.get(COOKIE.WEB_TOKEN);
          },
          set: function set(wt) {
            api.set(COOKIE.WEB_TOKEN, wt, {
              domain: DOMAIN.NEXON
            });
          }
        }, {
          key: "selectorCountry",
          get: function get() {
            try {
              var _JSON$parse = JSON.parse(api.get(COOKIE.INSIGN_GW)),
                selector = _JSON$parse.selector;
              return selector.country || "";
            } catch (error) {
              if (window.location.host.includes("signin.nexon.com")) {
                console.warn("Can not find selectorCountry");
              }
              return "";
            }
          }
          /** selector API 응답으로 설정된 platform 입니다 */
        }, {
          key: "selectorPlatform",
          get: function get() {
            try {
              return api.get(COOKIE.SELECTOR_PLATFORM);
            } catch (error) {
              if (window.location.host.includes("signin.nexon.com")) {
                console.warn("Can not find selectorPlatform");
              }
              return "";
            }
          }
          // #region 임시 쿠키
          /** @param {string} option */
        }, {
          key: "_generateTempCookieKey",
          value: function _generateTempCookieKey(gid, originKey, option) {
            return "".concat(gid, ":").concat(originKey).concat(option ? "::".concat(option) : "");
          }
        }, {
          key: "putGAMetaData",
          value: function putGAMetaData() {
            var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            if (!key) {
              return console.warn("key must not be empty string to put gameta");
            }
            var gaMetas = this._getGAMetaDatas();
            gaMetas[key] = value;
            this._setGAMetaDatas(gaMetas);
          }
        }, {
          key: "popGAMetaData",
          value: function popGAMetaData(key) {
            if (!key) {
              return console.warn("key must not be empty string to pop gameta");
            }
            var gaMetas = this._getGAMetaDatas();
            var gaMeta = gaMetas[key];
            delete gaMetas[key];
            if (Object.keys(gaMetas).length) {
              this._setGAMetaDatas(gaMetas);
            } else {
              this.clearGAMetaData();
            }
            return gaMeta;
          }
        }, {
          key: "clearGAMetaData",
          value: function clearGAMetaData() {
            api.remove(COOKIE.GAME_AUTH_SDK, {
              domain: DOMAIN.NEXON
            });
          }
        }, {
          key: "_getGAMetaDatas",
          value: function _getGAMetaDatas() {
            try {
              return JSON.parse(api.get(COOKIE.GAME_AUTH_SDK));
            } catch (error) {
              return {};
            }
          }
        }, {
          key: "getGAMetaData",
          value: function getGAMetaData(key) {
            return this._getGAMetaDatas()[key];
          }
        }, {
          key: "_setGAMetaDatas",
          value: function _setGAMetaDatas(metaObj) {
            try {
              api.set(COOKIE.GAME_AUTH_SDK, JSON.stringify(metaObj), {
                domain: DOMAIN.NEXON
              });
            } catch (error) {
              console.warn("Can not set ga meta data", error);
            }
          }
          // #endregion
          // #region Game Token
        }, {
          key: "putGameTokenInfo",
          value: function putGameTokenInfo(gid, guid, gt) {
            if (!gid) {
              console.warn("gid is required");
              return false;
            }
            var gameTokens = this._getGameTokens();
            gameTokens[gid] = [guid, gt];
            this._setGameTokens(gameTokens);
            var _this$getGameTokenInf = this.getGameTokenInfo(gid),
              savedGuid = _this$getGameTokenInf.guid,
              gameToken = _this$getGameTokenInf.gameToken;
            return guid === savedGuid && gt === gameToken;
          }
          /** @returns {{ guid, gameToken } | {}} */
        }, {
          key: "getGameTokenInfo",
          value: function getGameTokenInfo(gid) {
            var gtInfoArray = this._getGameTokens()[gid] || [];
            if (gtInfoArray.length !== 2) return {};
            return {
              guid: gtInfoArray[STORE_MANAGER_INDEX.GUID],
              gameToken: gtInfoArray[STORE_MANAGER_INDEX.GAME_TOKEN]
            };
          }
        }, {
          key: "removeGameTokenInfo",
          value: function removeGameTokenInfo(gid) {
            var gameTokens = this._getGameTokens();
            delete gameTokens[gid];
            this._setGameTokens(gameTokens);
          }
        }, {
          key: "_setGameTokens",
          value: function _setGameTokens(gtObject) {
            try {
              api.set(COOKIE.GAME_TOKEN, encrypt(JSON.stringify(gtObject)), {
                domain: DOMAIN.NEXON
              });
            } catch (error) {
              api.set(COOKIE.GAME_TOKEN, encrypt(JSON.stringify({})), {
                domain: DOMAIN.NEXON
              });
            }
          }
        }, {
          key: "_getGameTokens",
          value: function _getGameTokens() {
            try {
              var gt = api.get(COOKIE.GAME_TOKEN);
              return JSON.parse(decrypt(gt)) || {};
            } catch (error) {
              this._setGameTokens({});
              return {};
            }
          }
          // #endregion
          // #region Local Credentials
        }, {
          key: "putLocalCredentialInfo",
          value: function putLocalCredentialInfo() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              gid = _ref.gid,
              localCredentialID = _ref.localCredentialID,
              playNowUserID = _ref.playNowUserID;
            var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              crossSite = _ref2.crossSite;
            if (!gid) {
              return false;
            }
            var localCredentials = this._getLocalCredentials();
            var lcInfo = {
              gid: gid,
              localCredentialID: localCredentialID,
              playNowUserID: playNowUserID
            };
            localCredentials[gid] = lcInfo;
            this._setLocalCredentials(localCredentials);
            var _this$getLocalCredent = this.getLocalCredentialInfo(gid),
              lcID = _this$getLocalCredent.localCredentialID,
              pnUID = _this$getLocalCredent.playNowUserID;
            var result = localCredentialID === lcID && playNowUserID === pnUID;
            if (result && crossSite) {
              this.putGAMetaData(this._generateTempCookieKey(gid, LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, SDK_COOKIE.TEMP_OPTION.MOVE_TO_LS), lcInfo);
            }
            return result;
          }
          /** @returns {LOCAL_CREDENTIAL_INFO} */
        }, {
          key: "getLocalCredentialInfo",
          value: function getLocalCredentialInfo(gid) {
            var lcInfo = this._getLocalCredentials()[gid] || {};
            return Object.keys(lcInfo).length === 3 ? lcInfo : {};
          }
          /**
           *  INSIGN 과 웹게임의 domain 이 달라서
           * Logout 시 INSIGN 에서 삭제한 LC (in Local Storage) 를 웹게임에서 제거 합니다.
           * 로그아웃 후 웹게임으로 바로 redirect 하지 않는 등의 이유로 temp cookie 가 삭제 될 경우,
           * LC 자동 로그인 과정에서 invalid LC 응답 시 삭제 합니다.
           */
        }, {
          key: "checkCrossSiteLCForSignoutPhase",
          value: function checkCrossSiteLCForSignoutPhase(gid) {
            var lcTempCookie = this.popGAMetaData(this._generateTempCookieKey(gid, LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, SDK_COOKIE.TEMP_OPTION.REMOVE_FROM_LS));
            if (!lcTempCookie) return;
            var lcInfo = this._getLocalCredentials()[gid] || {};
            var validLcInLS = Object.keys(lcInfo).length === 3;
            var validLcInCookie = Object.keys(lcTempCookie || {}).length === 3;
            if (!validLcInLS || !validLcInCookie || lcInfo.localCredentialID !== lcTempCookie.localCredentialID || lcInfo.gid !== lcTempCookie.gid || lcInfo.playNowUserID !== lcTempCookie.playNowUserID) {
              console.warn("some information missed, suspect unexpected way to access");
            }
            this.removeLocalCredentialInfo(gid);
          }
          /**
           *  INSIGN 과 웹게임의 domain 이 달라서
           * INSIGN 에서 발급한 LC (in Local Storage) 를 Cookie 에 저장했다가
           * 웹게임에서 Game Auth 초기화 시 Local Storage 에 넣어 줍니다.
           */
        }, {
          key: "checkCrossSiteLCForSigninPhase",
          value: function checkCrossSiteLCForSigninPhase(gid) {
            var lcInfo = this._getLocalCredentials()[gid] || {};
            var validLcInLS = Object.keys(lcInfo).length === 3;
            var lcTempCookie = this.popGAMetaData(this._generateTempCookieKey(gid, LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, SDK_COOKIE.TEMP_OPTION.MOVE_TO_LS)) || {};
            var validLcInCookie = Object.keys(lcTempCookie).length === 3;
            if (validLcInLS && validLcInCookie) {
              console.warn("some information conflicts, suspect unexpected way to access");
            }
            if (validLcInLS) return;
            if (validLcInCookie) {
              this.putLocalCredentialInfo(lcTempCookie);
            }
          }
        }, {
          key: "removeLocalCredentialInfo",
          value: function removeLocalCredentialInfo(gid) {
            var _ref3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              _ref3$crossSite = _ref3.crossSite,
              crossSite = _ref3$crossSite === void 0 ? true : _ref3$crossSite;
            var localCredentials = this._getLocalCredentials();
            var lcInfo = localCredentials[gid];
            delete localCredentials[gid];
            this._setLocalCredentials(localCredentials);
            if (crossSite) {
              this.putGAMetaData(this._generateTempCookieKey(gid, LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, SDK_COOKIE.TEMP_OPTION.REMOVE_FROM_LS), lcInfo);
            }
          }
        }, {
          key: "_setLocalCredentials",
          value: function _setLocalCredentials(lcObject) {
            try {
              localStorage.setItem(LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, encrypt(JSON.stringify(lcObject)));
            } catch (error) {
              localStorage.setItem(LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL, encrypt(JSON.stringify({})));
            }
          }
        }, {
          key: "_getLocalCredentials",
          value: function _getLocalCredentials() {
            try {
              var lc = localStorage.getItem(LOCAL_STORAGE.PLAYNOW.LOCAL_CREDENTIAL);
              return lc ? JSON.parse(decrypt(lc)) : {};
            } catch (error) {
              this._setLocalCredentials({});
              return {};
            }
          }
          // #endregion
          // #region Insign Phase
        }, {
          key: "getInsignPhase",
          value: function getInsignPhase() {
            try {
              var phase = api.get(COOKIE.INSIGN_PHASE);
              return phase ? decrypt(phase) : "";
            } catch (error) {
              return "";
            }
          }
        }, {
          key: "removeInsignPhase",
          value: function removeInsignPhase() {
            api.remove(COOKIE.INSIGN_PHASE, {
              domain: DOMAIN.NEXON
            });
          }
        }, {
          key: "setInsignPhase",
          value: function setInsignPhase(phase) {
            api.set(COOKIE.INSIGN_PHASE, encrypt(phase), {
              domain: DOMAIN.NEXON
            });
          }
          // #endregion
        }]);
        return StoreManager2;
      }();
      storeManager = new StoreManager();
    }
  });

  // lib/managers/environment-manager.js
  function _typeof3(obj) {
    "@babel/helpers - typeof";

    return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof3(obj);
  }
  function _classCallCheck2(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey2(descriptor.key), descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey2(arg) {
    var key = _toPrimitive2(arg, "string");
    return _typeof3(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive2(input, hint) {
    if (_typeof3(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof3(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var ENV_LIST, EnvironmentManager, environmentManager;
  var init_environment_manager = __esm({
    "lib/managers/environment-manager.js": function lib_managers_environmentManagerJs() {
      "use strict";

      init_constant_util();
      ENV_LIST = ["local", "dev", "test", "pre", "live"];
      EnvironmentManager = /* @__PURE__ */function () {
        function EnvironmentManager2(env) {
          _classCallCheck2(this, EnvironmentManager2);
          this.setEnvironment(env, {
            ignoreLog: true
          });
        }
        _createClass2(EnvironmentManager2, [{
          key: "setEnvironment",
          value: function setEnvironment() {
            var env = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "li";
            var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              ignoreLog = _ref.ignoreLog;
            if (env.length === 2) {
              var index = ENV_LIST.findIndex(function (fullEnv) {
                return fullEnv.startsWith(env);
              });
              if (index !== -1) this.env = ENV_LIST[index];else this.env = "live";
            } else {
              this.env = ENV_LIST.includes(env) ? env : "live";
            }
            if (!ignoreLog) {}
            this.setApiEndPoint(this.env);
            return this.env;
          }
        }, {
          key: "setApiEndPoint",
          value: function setApiEndPoint(env) {
            this._apiEndPoint = getEnvVariables(env);
          }
          /** @returns {import('../constants/env-variable.enum').ENV_VARIABLES_BY_ENV} */
        }, {
          key: "apiUrl",
          get: function get() {
            return this._apiEndPoint;
          }
        }]);
        return EnvironmentManager2;
      }();
      environmentManager = new EnvironmentManager();
    }
  });

  // lib/managers/index.js
  var init_managers = __esm({
    "lib/managers/index.js": function lib_managers_indexJs() {
      "use strict";

      init_store_manager();
      init_environment_manager();
    }
  });

  // node_modules/whatwg-fetch/fetch.js
  function _typeof4(obj) {
    "@babel/helpers - typeof";

    return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof4(obj);
  }
  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }
  function normalizeName(name) {
    if (typeof name !== "string") {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") {
      throw new TypeError('Invalid character in header field name: "' + name + '"');
    }
    return name.toLowerCase();
  }
  function normalizeValue(value) {
    if (typeof value !== "string") {
      value = String(value);
    }
    return value;
  }
  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return {
          done: value === void 0,
          value: value
        };
      }
    };
    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }
    return iterator;
  }
  function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        if (header.length != 2) {
          throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        }
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }
  function consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) {
      return Promise.reject(new TypeError("Already read"));
    }
    body.bodyUsed = true;
  }
  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }
  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }
  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
  }
  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join("");
  }
  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }
  function Body() {
    this.bodyUsed = false;
    this._initBody = function (body) {
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._noBody = true;
        this._bodyText = "";
      } else if (typeof body === "string") {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }
      if (!this.headers.get("content-type")) {
        if (typeof body === "string") {
          this.headers.set("content-type", "text/plain;charset=UTF-8");
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set("content-type", this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
      }
    };
    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }
        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error("could not read FormData body as blob");
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };
    }
    this.arrayBuffer = function () {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed;
        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
        } else {
          return Promise.resolve(this._bodyArrayBuffer);
        }
      } else if (support.blob) {
        return this.blob().then(readBlobAsArrayBuffer);
      } else {
        throw new Error("could not read as ArrayBuffer");
      }
    };
    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }
      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error("could not read FormData body as text");
      } else {
        return Promise.resolve(this._bodyText);
      }
    };
    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }
    this.json = function () {
      return this.text().then(JSON.parse);
    };
    return this;
  }
  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }
  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    }
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError("Already read");
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function () {
      if ("AbortController" in g) {
        var ctrl = new AbortController();
        return ctrl.signal;
      }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) {
      throw new TypeError("Body not allowed for GET or HEAD requests");
    }
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
      if (options.cache === "no-store" || options.cache === "no-cache") {
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          this.url = this.url.replace(reParamSearch, "$1_=" + ( /* @__PURE__ */new Date()).getTime());
        } else {
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + ( /* @__PURE__ */new Date()).getTime();
        }
      }
    }
  }
  function decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split("=");
        var name = split.shift().replace(/\+/g, " ");
        var value = split.join("=").replace(/\+/g, " ");
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }
  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    preProcessedHeaders.split("\r").map(function (header) {
      return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function (line) {
      var parts = line.split(":");
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(":").trim();
        try {
          headers.append(key, value);
        } catch (error) {
          console.warn("Response " + error.message);
        }
      }
    });
    return headers;
  }
  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    }
    if (!options) {
      options = {};
    }
    this.type = "default";
    this.status = options.status === void 0 ? 200 : options.status;
    if (this.status < 200 || this.status > 599) {
      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    }
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === void 0 ? "" : "" + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
  }
  function fetch2(input, init2) {
    return new Promise(function (resolve, reject) {
      var request3 = new Request(input, init2);
      if (request3.signal && request3.signal.aborted) {
        return reject(new DOMException("Aborted", "AbortError"));
      }
      var xhr = new XMLHttpRequest();
      function abortXhr() {
        xhr.abort();
      }
      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || "")
        };
        options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
        var body = "response" in xhr ? xhr.response : xhr.responseText;
        setTimeout(function () {
          resolve(new Response(body, options));
        }, 0);
      };
      xhr.onerror = function () {
        setTimeout(function () {
          reject(new TypeError("Network request failed"));
        }, 0);
      };
      xhr.ontimeout = function () {
        setTimeout(function () {
          reject(new TypeError("Network request failed"));
        }, 0);
      };
      xhr.onabort = function () {
        setTimeout(function () {
          reject(new DOMException("Aborted", "AbortError"));
        }, 0);
      };
      function fixUrl(url) {
        try {
          return url === "" && g.location.href ? g.location.href : url;
        } catch (e) {
          return url;
        }
      }
      xhr.open(request3.method, fixUrl(request3.url), true);
      if (request3.credentials === "include") {
        xhr.withCredentials = true;
      } else if (request3.credentials === "omit") {
        xhr.withCredentials = false;
      }
      if ("responseType" in xhr) {
        if (support.blob) {
          xhr.responseType = "blob";
        } else if (support.arrayBuffer) {
          xhr.responseType = "arraybuffer";
        }
      }
      if (init2 && _typeof4(init2.headers) === "object" && !(init2.headers instanceof Headers || g.Headers && init2.headers instanceof g.Headers)) {
        var names = [];
        Object.getOwnPropertyNames(init2.headers).forEach(function (name) {
          names.push(normalizeName(name));
          xhr.setRequestHeader(name, normalizeValue(init2.headers[name]));
        });
        request3.headers.forEach(function (value, name) {
          if (names.indexOf(name) === -1) {
            xhr.setRequestHeader(name, value);
          }
        });
      } else {
        request3.headers.forEach(function (value, name) {
          xhr.setRequestHeader(name, value);
        });
      }
      if (request3.signal) {
        request3.signal.addEventListener("abort", abortXhr);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            request3.signal.removeEventListener("abort", abortXhr);
          }
        };
      }
      xhr.send(typeof request3._bodyInit === "undefined" ? null : request3._bodyInit);
    });
  }
  var g, support, viewClasses, isArrayBufferView, methods, redirectStatuses, DOMException;
  var init_fetch = __esm({
    "node_modules/whatwg-fetch/fetch.js": function node_modules_whatwgFetch_fetchJs() {
      g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self ||
      // eslint-disable-next-line no-undef
      typeof window !== "undefined" && window || {};
      support = {
        searchParams: "URLSearchParams" in g,
        iterable: "Symbol" in g && "iterator" in Symbol,
        blob: "FileReader" in g && "Blob" in g && function () {
          try {
            new Blob();
            return true;
          } catch (e) {
            return false;
          }
        }(),
        formData: "FormData" in g,
        arrayBuffer: "ArrayBuffer" in g
      };
      if (support.arrayBuffer) {
        viewClasses = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"];
        isArrayBufferView = ArrayBuffer.isView || function (obj) {
          return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
      }
      Headers.prototype.append = function (name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ", " + value : value;
      };
      Headers.prototype["delete"] = function (name) {
        delete this.map[normalizeName(name)];
      };
      Headers.prototype.get = function (name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
      };
      Headers.prototype.has = function (name) {
        return this.map.hasOwnProperty(normalizeName(name));
      };
      Headers.prototype.set = function (name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
      };
      Headers.prototype.forEach = function (callback, thisArg) {
        for (var name in this.map) {
          if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
          }
        }
      };
      Headers.prototype.keys = function () {
        var items = [];
        this.forEach(function (value, name) {
          items.push(name);
        });
        return iteratorFor(items);
      };
      Headers.prototype.values = function () {
        var items = [];
        this.forEach(function (value) {
          items.push(value);
        });
        return iteratorFor(items);
      };
      Headers.prototype.entries = function () {
        var items = [];
        this.forEach(function (value, name) {
          items.push([name, value]);
        });
        return iteratorFor(items);
      };
      if (support.iterable) {
        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
      }
      methods = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
      Request.prototype.clone = function () {
        return new Request(this, {
          body: this._bodyInit
        });
      };
      Body.call(Request.prototype);
      Body.call(Response.prototype);
      Response.prototype.clone = function () {
        return new Response(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Headers(this.headers),
          url: this.url
        });
      };
      Response.error = function () {
        var response = new Response(null, {
          status: 200,
          statusText: ""
        });
        response.status = 0;
        response.type = "error";
        return response;
      };
      redirectStatuses = [301, 302, 303, 307, 308];
      Response.redirect = function (url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
          throw new RangeError("Invalid status code");
        }
        return new Response(null, {
          status: status,
          headers: {
            location: url
          }
        });
      };
      DOMException = g.DOMException;
      try {
        new DOMException();
      } catch (err) {
        DOMException = function DOMException2(message, name) {
          this.message = message;
          this.name = name;
          var error = Error(message);
          this.stack = error.stack;
        };
        DOMException.prototype = Object.create(Error.prototype);
        DOMException.prototype.constructor = DOMException;
      }
      fetch2.polyfill = true;
      if (!g.fetch) {
        g.fetch = fetch2;
        g.Headers = Headers;
        g.Request = Request;
        g.Response = Response;
      }
    }
  });

  // lib/apis/core/insign-error.class.js
  function _typeof5(obj) {
    "@babel/helpers - typeof";

    return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof5(obj);
  }
  function _defineProperties3(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey3(descriptor.key), descriptor);
    }
  }
  function _createClass3(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties3(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties3(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey3(arg) {
    var key = _toPrimitive3(arg, "string");
    return _typeof5(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive3(input, hint) {
    if (_typeof5(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof5(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _classCallCheck3(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var InsignError;
  var init_insign_error_class = __esm({
    "lib/apis/core/insign-error.class.js": function lib_apis_core_insignErrorClassJs() {
      "use strict";

      InsignError = /* @__PURE__ */_createClass3(function InsignError2() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          code = _ref.code,
          name = _ref.name,
          message = _ref.message,
          httpStatus = _ref.httpStatus,
          rawResponseData = _ref.rawResponseData;
        _classCallCheck3(this, InsignError2);
        this.code = code;
        this.name = name;
        this.message = message;
        this.httpStatus = httpStatus;
        this.rawResponseData = rawResponseData;
      });
    }
  });

  // lib/apis/core/insign-response.class.js
  function _typeof6(obj) {
    "@babel/helpers - typeof";

    return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof6(obj);
  }
  function _classCallCheck4(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties4(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey4(descriptor.key), descriptor);
    }
  }
  function _createClass4(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties4(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties4(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey4(arg) {
    var key = _toPrimitive4(arg, "string");
    return _typeof6(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive4(input, hint) {
    if (_typeof6(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof6(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var _InsignResponse;
  var init_insign_response_class = __esm({
    "lib/apis/core/insign-response.class.js": function lib_apis_core_insignResponseClassJs() {
      "use strict";

      init_insign_error_class();
      _InsignResponse = /* @__PURE__ */function () {
        function InsignResponse2() {
          var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
            success = _ref.success,
            data = _ref.data,
            error = _ref.error;
          _classCallCheck4(this, InsignResponse2);
          this.success = success;
          this.data = data;
          if (error) this.error = new InsignError(error);
        }
        _createClass4(InsignResponse2, [{
          key: "serialize",
          value: function serialize() {
            return JSON.stringify(this);
          }
        }]);
        return InsignResponse2;
      }();
    }
  });

  // lib/apis/core/response-builder.class.js
  function _typeof7(obj) {
    "@babel/helpers - typeof";

    return _typeof7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof7(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey5(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _classCallCheck5(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties5(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey5(descriptor.key), descriptor);
    }
  }
  function _createClass5(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties5(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties5(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey5(arg) {
    var key = _toPrimitive5(arg, "string");
    return _typeof7(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive5(input, hint) {
    if (_typeof7(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof7(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var _ResponseBuilder;
  var init_response_builder_class = __esm({
    "lib/apis/core/response-builder.class.js": function lib_apis_core_responseBuilderClassJs() {
      "use strict";

      init_insign_response_class();
      _ResponseBuilder = /* @__PURE__ */function () {
        function ResponseBuilder2(success) {
          var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          _classCallCheck5(this, ResponseBuilder2);
          this._success = !!success;
          if (options.functionName) {
            this._functionName = options.functionName;
          }
        }
        _createClass5(ResponseBuilder2, [{
          key: "data",
          value: function data(_data) {
            this._data = _data;
            return this;
          }
          /** @param {number} status */
        }, {
          key: "httpStatus",
          value: function httpStatus(_httpStatus) {
            if (this._success) {
              console.warn("httpStatus is supposed to have value when failed");
            }
            this._error = _objectSpread(_objectSpread({}, this._error), {}, {
              httpStatus: _httpStatus
            });
            return this;
          }
          /**
           * @param {object} obj
           * @param {number|string} obj.code
           * @param {string} obj.name
           * @param {string} obj.message
           */
        }, {
          key: "error",
          value: function error(_ref) {
            var code = _ref.code,
              name = _ref.name,
              message = _ref.message;
            if (this._success) {
              console.warn("error is supposed to have values when failed");
            }
            this._error = _objectSpread(_objectSpread({}, this._error), {}, {
              code: code,
              name: name,
              message: message
            });
            return this;
          }
        }, {
          key: "errorRawResponseData",
          value: function errorRawResponseData(rawResponseData) {
            if (this._success) {
              console.warn("errorRawResponseData is supposed to have value when failed");
            }
            this._error = _objectSpread(_objectSpread({}, this._error), {}, {
              rawResponseData: rawResponseData
            });
            return this;
          }
          /** @returns {InsignResponse} */
        }, {
          key: "build",
          value: function build() {
            if (this._success) {
              if (this._error) {
                console.warn("error is supposed to have values when failed");
              }
            } else if (!this._error.rawResponseData) {}
            var result = new _InsignResponse({
              success: this._success,
              data: this._data,
              error: this._error
            });
            return result;
          }
        }]);
        return ResponseBuilder2;
      }();
    }
  });

  // lib/apis/core/request.js
  function _regeneratorRuntime2() {
    "use strict";

    _regeneratorRuntime2 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof8(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof8(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator2(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep2(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function (key) {
        _defineProperty2(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    key = _toPropertyKey6(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey6(arg) {
    var key = _toPrimitive6(arg, "string");
    return _typeof8(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive6(input, hint) {
    if (_typeof8(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof8(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _typeof8(obj) {
    "@babel/helpers - typeof";

    return _typeof8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof8(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function getDefaultHeaders() {
    var headers = {
      "Content-Type": "application/json"
    };
    return headers;
  }
  var _excluded, request;
  var init_request = __esm({
    "lib/apis/core/request.js": function lib_apis_core_requestJs() {
      "use strict";

      init_constants();
      init_fetch();
      init_response_builder_class();
      _excluded = ["body", "headers", "method", "functionName"];
      request = function request2(url) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
          body = _ref.body,
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers,
          _ref$method = _ref.method,
          method = _ref$method === void 0 ? "POST" : _ref$method,
          _ref$functionName = _ref.functionName,
          functionName = _ref$functionName === void 0 ? "" : _ref$functionName,
          options = _objectWithoutProperties(_ref, _excluded);
        if (typeof url !== "string") {
          console.warn("url is supposed to be string");
          return Promise.reject(new Error("invalid parameter with url"));
        }
        var bodyString = _typeof8(body) === "object" ? JSON.stringify(body) : body;
        var reqHeaders = _objectSpread2(_objectSpread2({}, getDefaultHeaders()), headers);
        var reqOptions = _objectSpread2({
          method: method,
          body: bodyString,
          headers: reqHeaders,
          mode: "cors",
          credentials: "include"
        }, options);
        return new Promise( /* @__PURE__ */function () {
          var _ref2 = _asyncToGenerator2( /* @__PURE__ */_regeneratorRuntime2().mark(function _callee2(resolve) {
            return _regeneratorRuntime2().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  fetch(url, reqOptions).then( /* @__PURE__ */function () {
                    var _ref3 = _asyncToGenerator2( /* @__PURE__ */_regeneratorRuntime2().mark(function _callee(result) {
                      var data;
                      return _regeneratorRuntime2().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return result.json();
                          case 3:
                            _context.t0 = _context.sent;
                            if (_context.t0) {
                              _context.next = 6;
                              break;
                            }
                            _context.t0 = {};
                          case 6:
                            data = _context.t0;
                            if (result.ok) {
                              resolve(new _ResponseBuilder(true, {
                                functionName: functionName
                              }).data(data).build());
                            } else {
                              resolve(new _ResponseBuilder(false, {
                                functionName: functionName
                              }).httpStatus(result.status).error(error_code_enum_default.GAME_AUTH.API.RESPONSE_FAIL).errorRawResponseData(data).build());
                            }
                            _context.next = 14;
                            break;
                          case 10:
                            _context.prev = 10;
                            _context.t1 = _context["catch"](0);
                            console.warn("[game-auth] Failed ".concat(functionName), JSON.stringify(_context.t1, null, 2));
                            return _context.abrupt("return", resolve(new _ResponseBuilder(false, {
                              functionName: functionName
                            }).httpStatus(result.status).error(error_code_enum_default.GAME_AUTH.API.RESPONSE_EXCEPTION).errorRawResponseData(_context.t1).build()));
                          case 14:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee, null, [[0, 10]]);
                    }));
                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }())["catch"](function (error) {
                    console.warn("[game-auth] RES ".concat(functionName, " error"), error);
                    return resolve(new _ResponseBuilder(false, {
                      functionName: functionName
                    }).error(error_code_enum_default.GAME_AUTH.API.FETCH_FAIL).errorRawResponseData(error).build());
                  });
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      };
    }
  });

  // lib/apis/core/request.class.js
  function _typeof9(obj) {
    "@babel/helpers - typeof";

    return _typeof9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof9(obj);
  }
  function _regeneratorRuntime3() {
    "use strict";

    _regeneratorRuntime3 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof9(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof9(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator3(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep3(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep3(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck6(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties6(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey7(descriptor.key), descriptor);
    }
  }
  function _createClass6(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties6(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties6(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey7(arg) {
    var key = _toPrimitive7(arg, "string");
    return _typeof9(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive7(input, hint) {
    if (_typeof9(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof9(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Request2;
  var init_request_class = __esm({
    "lib/apis/core/request.class.js": function lib_apis_core_requestClassJs() {
      "use strict";

      init_utils();
      init_request();
      Request2 = /* @__PURE__ */function () {
        function Request4() {
          _classCallCheck6(this, Request4);
        }
        _createClass6(Request4, [{
          key: "request",
          value: ( /** @returns {import('./insign-response.class').InsignResponse} error 는 API error */
          function () {
            var _request2 = _asyncToGenerator3( /* @__PURE__ */_regeneratorRuntime3().mark(function _callee(url, body, headers) {
              var _ref,
                _ref$method,
                method,
                functionName,
                _ref$snakeToCamel,
                snakeToCamel3,
                result,
                _args = arguments;
              return _regeneratorRuntime3().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _ref = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, _ref$method = _ref.method, method = _ref$method === void 0 ? "POST" : _ref$method, functionName = _ref.functionName, _ref$snakeToCamel = _ref.snakeToCamel, snakeToCamel3 = _ref$snakeToCamel === void 0 ? true : _ref$snakeToCamel;
                    _context.next = 3;
                    return request(url, {
                      method: method,
                      body: body,
                      headers: headers,
                      functionName: functionName
                    });
                  case 3:
                    result = _context.sent;
                    if (result.success && snakeToCamel3) result.data = snakeToCamelForObject(result.data);
                    return _context.abrupt("return", result);
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function request3(_x, _x2, _x3) {
              return _request2.apply(this, arguments);
            }
            return request3;
          }())
        }]);
        return Request4;
      }();
    }
  });

  // lib/apis/core/index.js
  var core_exports = {};
  __export(core_exports, {
    InsignResponse: function InsignResponse() {
      return _InsignResponse;
    },
    Request: function Request() {
      return Request2;
    },
    ResponseBuilder: function ResponseBuilder() {
      return _ResponseBuilder;
    }
  });
  var init_core = __esm({
    "lib/apis/core/index.js": function lib_apis_core_indexJs() {
      "use strict";

      init_request_class();
      init_response_builder_class();
      init_insign_response_class();
    }
  });

  // lib/apis/ias.js
  function _typeof10(obj) {
    "@babel/helpers - typeof";

    return _typeof10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof10(obj);
  }
  function _classCallCheck7(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties7(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey8(descriptor.key), descriptor);
    }
  }
  function _createClass7(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties7(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties7(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey8(arg) {
    var key = _toPrimitive8(arg, "string");
    return _typeof10(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive8(input, hint) {
    if (_typeof10(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof10(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get4(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get.apply(this, arguments);
  }
  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }
    return object;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self2, call) {
    if (call && (_typeof10(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self2);
  }
  function _assertThisInitialized(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf(o);
  }
  var IAS, IasAPI, _iasApi;
  var init_ias = __esm({
    "lib/apis/ias.js": function lib_apis_iasJs() {
      "use strict";

      init_managers();
      init_core();
      IAS = {
        ISSUE_GAME_TOKEN_BY_TICKET: "/v1/issue/game-token/by-ticket",
        ISSUE_WEB_TOKEN_BY_GAME_TOKEN: "/v1/issue/web-token/by-game-token",
        ISSUE_TICKET_BY_WEB_TOKEN: "/v1/issue/ticket/by-web-token",
        VERIFY_GAME_TOKEN: "/v1/verify/game-token",
        EXPIRE_GAME_TOKEN: "/v1/expire/game-token"
      };
      IasAPI = /* @__PURE__ */function (_Request) {
        _inherits(IasAPI2, _Request);
        var _super = _createSuper(IasAPI2);
        function IasAPI2() {
          _classCallCheck7(this, IasAPI2);
          return _super.apply(this, arguments);
        }
        _createClass7(IasAPI2, [{
          key: "request",
          value: function request3(path, body, headers, options) {
            var url = "".concat(environmentManager.apiUrl.IAS_API_URL).concat(path);
            return _get(_getPrototypeOf(IasAPI2.prototype), "request", this).call(this, url, body, headers, options);
          }
        }, {
          key: "issueGameTokenByTicket",
          value: function issueGameTokenByTicket() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              ticket = _ref.ticket,
              locale = _ref.locale;
            var iasLocale = (locale || "").replace("-", "_");
            var path = "".concat(IAS.ISSUE_GAME_TOKEN_BY_TICKET).concat(locale ? "?locale=".concat(iasLocale) : "");
            var body = {};
            var headers = {
              "x-ias-ticket": ticket
            };
            return this.request(path, body, headers, {
              functionName: "issueGameTokenByTicket"
            });
          }
        }, {
          key: "issueWebTokenByGameToken",
          value: function issueWebTokenByGameToken(gameToken) {
            var path = IAS.ISSUE_WEB_TOKEN_BY_GAME_TOKEN;
            var body = {};
            var headers = {
              "x-ias-game-token": gameToken
            };
            return this.request(path, body, headers, {
              functionName: "issueWebTokenByGameToken"
            });
          }
        }, {
          key: "issueTicketByWebToken",
          value: function issueTicketByWebToken() {
            var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              gid = _ref2.gid,
              webToken = _ref2.webToken;
            var path = IAS.ISSUE_TICKET_BY_WEB_TOKEN;
            var body = {
              gid: gid
            };
            var headers = {
              "x-ias-web-token": webToken
            };
            return this.request(path, body, headers, {
              functionName: "issueTicketByWebToken"
            });
          }
        }, {
          key: "verifyGameToken",
          value: function verifyGameToken(gameToken) {
            var path = IAS.VERIFY_GAME_TOKEN;
            var headers = {
              "x-ias-game-token": gameToken
            };
            return this.request(path, null, headers, {
              functionName: "verifyGameToken"
            });
          }
        }, {
          key: "expireGameToken",
          value: function expireGameToken(gameToken) {
            var path = IAS.EXPIRE_GAME_TOKEN;
            var headers = {
              "x-ias-game-token": gameToken
            };
            return this.request(path, null, headers, {
              functionName: "expireGameToken"
            });
          }
        }]);
        return IasAPI2;
      }(Request2);
      _iasApi = new IasAPI();
    }
  });

  // lib/apis/bolt.js
  function _typeof11(obj) {
    "@babel/helpers - typeof";

    return _typeof11 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof11(obj);
  }
  function _regeneratorRuntime4() {
    "use strict";

    _regeneratorRuntime4 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof11(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof11(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function ownKeys3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread3(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys3(Object(source), true).forEach(function (key) {
        _defineProperty3(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty3(obj, key, value) {
    key = _toPropertyKey9(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function asyncGeneratorStep4(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator4(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep4(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep4(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck8(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties8(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey9(descriptor.key), descriptor);
    }
  }
  function _createClass8(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties8(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties8(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey9(arg) {
    var key = _toPrimitive9(arg, "string");
    return _typeof11(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive9(input, hint) {
    if (_typeof11(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof11(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _get2() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get2 = Reflect.get.bind();
    } else {
      _get2 = function _get4(target, property, receiver) {
        var base = _superPropBase2(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get2.apply(this, arguments);
  }
  function _superPropBase2(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf2(object);
      if (object === null) break;
    }
    return object;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof11(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  var BOLT, _BOLT_ENUM, ERROR_CODE, BoltAPI, _boltApi;
  var init_bolt = __esm({
    "lib/apis/bolt.js": function lib_apis_boltJs() {
      "use strict";

      init_managers();
      init_core();
      init_constants();
      BOLT = {
        SIGNIN_WITH_TICKET: "/sdk/signInWithTicket.nx",
        SIGNIN_WITH_WEBTOKEN: "/sdk/signInWithWebToken.nx",
        REACTIVATE_ACCOUNT: "/sdk/reactivateAccount.nx",
        TERMS_BY_GAME_TOKEN: "/sdk/termsByGameToken.nx",
        TERMS_BY_TICKET: "/sdk/termsByTicket.nx",
        AGREE_TERMS_WITH_TICKET: "/sdk/agreeTermsWithTicket.nx",
        AGREE_TERMS: "/sdk/agreeTerms.nx",
        RECOVER_USER: "/v2/web/guid/recover/user",
        LOGOUT_SERVICE: "/sdk/logoutSVC.nx"
      };
      _BOLT_ENUM = {
        MEM_TYPE: {
          PLAYNOW: 9996
        }
      };
      ERROR_CODE = {
        INVALID_GAME_TOKEN: 5001,
        INVALID_GUID: 1102
      };
      BoltAPI = /* @__PURE__ */function (_Request) {
        _inherits2(BoltAPI2, _Request);
        var _super = _createSuper2(BoltAPI2);
        function BoltAPI2() {
          _classCallCheck8(this, BoltAPI2);
          return _super.apply(this, arguments);
        }
        _createClass8(BoltAPI2, [{
          key: "request",
          value: function () {
            var _request = _asyncToGenerator4( /* @__PURE__ */_regeneratorRuntime4().mark(function _callee(path, body, headers, options) {
              var url, _yield$_get$call, success, data, error, result, errorCode, boltError, _ref, functionName;
              return _regeneratorRuntime4().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    url = "".concat(environmentManager.apiUrl.BOLT_API_URL).concat(path);
                    _context.next = 3;
                    return _get2(_getPrototypeOf2(BoltAPI2.prototype), "request", this).call(this, url, body, headers, _objectSpread3(_objectSpread3({}, options), {}, {
                      snakeToCamel: false
                    }));
                  case 3:
                    _yield$_get$call = _context.sent;
                    success = _yield$_get$call.success;
                    data = _yield$_get$call.data;
                    error = _yield$_get$call.error;
                    if (success) {
                      _context.next = 9;
                      break;
                    }
                    return _context.abrupt("return", {
                      success: success,
                      error: error
                    });
                  case 9:
                    result = data.result, errorCode = data.errorCode, boltError = data.error;
                    if (!(errorCode === 0)) {
                      _context.next = 12;
                      break;
                    }
                    return _context.abrupt("return", {
                      success: success,
                      data: result
                    });
                  case 12:
                    if (!(path === BOLT.RECOVER_USER && !boltError)) {
                      _context.next = 14;
                      break;
                    }
                    return _context.abrupt("return", {
                      success: success,
                      data: data
                    });
                  case 14:
                    _ref = options || {}, functionName = _ref.functionName;
                    return _context.abrupt("return", new _ResponseBuilder(false, {
                      functionName: functionName
                    }).error(error_code_enum_default.GAME_AUTH.API.RESPONSE_FAIL).errorRawResponseData(data).build());
                  case 16:
                  case "end":
                    return _context.stop();
                }
              }, _callee, this);
            }));
            function request3(_x, _x2, _x3, _x4) {
              return _request.apply(this, arguments);
            }
            return request3;
          }()
          // #region Signin series
        }, {
          key: "signInWithTicketNx",
          value: function signInWithTicketNx(_ref2) {
            var ticket = _ref2.ticket,
              locale = _ref2.locale,
              uuid = _ref2.uuid,
              _ref2$termsApiVer = _ref2.termsApiVer,
              termsApiVer = _ref2$termsApiVer === void 0 ? 2 : _ref2$termsApiVer,
              _ref2$os = _ref2.os,
              os = _ref2$os === void 0 ? "desktop" : _ref2$os;
            var boltLocale = (locale || navigator.language || "").replace("-", "_");
            var path = BOLT.SIGNIN_WITH_TICKET;
            var headers = {
              "ias-ticket": ticket
            };
            var body = {
              os: os,
              locale: boltLocale,
              uuid: uuid,
              termsApiVer: termsApiVer
            };
            return this.request(path, body, headers, {
              functionName: "signInWithTicketNx"
            });
          }
        }, {
          key: "signInWithWebTokenNx",
          value: function signInWithWebTokenNx(_ref3) {
            var gid = _ref3.gid,
              webToken = _ref3.webToken,
              locale = _ref3.locale,
              uuid = _ref3.uuid,
              _ref3$os = _ref3.os,
              os = _ref3$os === void 0 ? "desktop" : _ref3$os,
              guid = _ref3.guid,
              gameToken = _ref3.gameToken;
            var boltLocale = (locale || navigator.language || "").replace("-", "_");
            var path = BOLT.SIGNIN_WITH_WEBTOKEN;
            var headers = {
              gid: gid,
              "ias-webtoken": webToken
            };
            var body = {
              os: os,
              locale: boltLocale,
              uuid: uuid,
              guid: guid,
              gameToken: gameToken
            };
            return this.request(path, body, headers, {
              functionName: "signInWithWebTokenNx"
            });
          }
        }, {
          key: "reactivateAccount",
          value: function reactivateAccount(_ref4) {
            var gid = _ref4.gid,
              _ref4$npSN = _ref4.npSN,
              npSN = _ref4$npSN === void 0 ? "" : _ref4$npSN,
              memberId = _ref4.memberId,
              memberType = _ref4.memberType,
              npaCode = _ref4.npaCode;
            var path = BOLT.REACTIVATE_ACCOUNT;
            var headers = {
              gid: gid,
              npSN: npSN,
              guid: npSN,
              "x-bolt-request-mode": npaCode ? "p" : "e"
            };
            var body = {
              memberId: memberId,
              memberType: memberType,
              npaCode: npaCode
            };
            return this.request(path, body, headers, {
              functionName: "reactivateAccount"
            });
          }
          // #endregion
          // #region Terms series
          /**
           * @example
           * 
           * {
              errorCode: 0,
              result: {
                npSN: 10030000000001214,
                guid: '10030000000001214',
                memType: 9996,
                termsAgree: [
                  {
                    termID: 296,
                    title: 'test',
                    type: ['toast', 'push', 'adToast', 'nightToast'],
                    optional: 1,
                    cTermsID: ['318'],
                    isAgree: 1,
                    isUpdate: 0,
                  },
                  {
                    termID: 312,
                    title: '광고성정보 수신 동의',
                    type: [],
                    optional: 1,
                    isAgree: 1,
                    isUpdate: 0,
                  },
                ],
              },
              errorText: 'Success',
              errorDetail: '',
            }
           */
        }, {
          key: "termsByGameTokenNx",
          value: function termsByGameTokenNx(_ref5) {
            var gid = _ref5.gid,
              guid = _ref5.guid,
              gameToken = _ref5.gameToken,
              _ref5$os = _ref5.os,
              os = _ref5$os === void 0 ? "desktop" : _ref5$os;
            var path = BOLT.TERMS_BY_GAME_TOKEN;
            var headers = {
              gid: gid,
              guid: guid,
              "x-insign-game-token": gameToken
            };
            var body = {
              os: os
            };
            return this.request(path, body, headers, {
              functionName: "termsByGameTokenNx"
            });
          }
        }, {
          key: "termsByTicket",
          value: function termsByTicket(_ref6) {
            var gid = _ref6.gid,
              guid = _ref6.guid,
              ticket = _ref6.ticket,
              _ref6$os = _ref6.os,
              os = _ref6$os === void 0 ? "desktop" : _ref6$os;
            var path = BOLT.TERMS_BY_TICKET;
            var headers = {
              gid: gid,
              guid: guid,
              "ias-ticket": ticket
            };
            var body = {
              os: os
            };
            return this.request(path, body, headers, {
              functionName: "termsByTicket"
            });
          }
          // #endregion
        }, {
          key: "agreeTermsWithTicketNx",
          value: function agreeTermsWithTicketNx(_ref7) {
            var ticket = _ref7.ticket,
              uuid = _ref7.uuid,
              terms = _ref7.terms;
            var path = BOLT.AGREE_TERMS_WITH_TICKET;
            var headers = {
              "ias-ticket": ticket
            };
            var body = {
              uuid: uuid,
              terms: terms
            };
            return this.request(path, body, headers, {
              functionName: "agreeTermsWithTicketNx"
            });
          }
        }, {
          key: "agreeTermsNx",
          value: function agreeTermsNx(_ref8) {
            var terms = _ref8.terms,
              gid = _ref8.gid,
              gameToken = _ref8.gameToken,
              guid = _ref8.guid,
              uuid = _ref8.uuid,
              locale = _ref8.locale,
              _ref8$os = _ref8.os,
              os = _ref8$os === void 0 ? "desktop" : _ref8$os;
            var boltLocale = (locale || navigator.language || "").replace("-", "_");
            var path = BOLT.AGREE_TERMS;
            var headers = {
              gid: gid,
              guid: guid,
              "x-insign-game-token": gameToken,
              "x-bolt-request-mode": "p"
            };
            var body = {
              uuid: uuid,
              locale: boltLocale,
              os: os,
              terms: terms
            };
            return this.request(path, body, headers, {
              functionName: "agreeTermsNx"
            });
          }
          /**
           *  Recover User 는 기존 BOLT 와 응답 형식이 다릅니다.
           *
           * success ( HttpStatus 200 )
           *    { "guid":"10030000000000001" }
           * error response ( HttpStatus 4xx / 5xx )
           *  {
           *    "error": {
           *      "code": 1302,
           *      "name": "We don't have account data to recover.",
           *      "message": "We don't have account data to recover."
           *    }
           *  }
           */
        }, {
          key: "recoverUser",
          value: function recoverUser(_ref9) {
            var ticket = _ref9.ticket,
              gid = _ref9.gid,
              uuid = _ref9.uuid;
            var path = BOLT.RECOVER_USER;
            var headers = {
              "x-token": ticket
            };
            var body = {
              gid: gid,
              uuid: uuid
            };
            return this.request(path, body, headers, {
              functionName: "recoverUser"
            });
          }
        }, {
          key: "logoutService",
          value: function logoutService(_ref10) {
            var gid = _ref10.gid,
              guid = _ref10.guid,
              gameToken = _ref10.gameToken,
              uuid = _ref10.uuid;
            var path = BOLT.LOGOUT_SERVICE;
            var headers = {
              gid: gid,
              guid: guid,
              "x-insign-game-token": gameToken,
              "x-bolt-request-mode": "p"
            };
            var body = {
              uuid: uuid
            };
            return this.request(path, body, headers, {
              functionName: "logoutService"
            });
          }
        }]);
        return BoltAPI2;
      }(Request2);
      _boltApi = new BoltAPI();
    }
  });

  // lib/apis/ims.js
  function _typeof12(obj) {
    "@babel/helpers - typeof";

    return _typeof12 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof12(obj);
  }
  function _regeneratorRuntime5() {
    "use strict";

    _regeneratorRuntime5 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof12(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof12(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep5(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator5(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep5(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep5(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck9(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties9(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey10(descriptor.key), descriptor);
    }
  }
  function _createClass9(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties9(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties9(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey10(arg) {
    var key = _toPrimitive10(arg, "string");
    return _typeof12(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive10(input, hint) {
    if (_typeof12(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof12(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _get3() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get3 = Reflect.get.bind();
    } else {
      _get3 = function _get4(target, property, receiver) {
        var base = _superPropBase3(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get3.apply(this, arguments);
  }
  function _superPropBase3(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf3(object);
      if (object === null) break;
    }
    return object;
  }
  function _inherits3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf3(subClass, superClass);
  }
  function _setPrototypeOf3(o, p) {
    _setPrototypeOf3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf3(o, p);
  }
  function _createSuper3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct3();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf3(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf3(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn3(this, result);
    };
  }
  function _possibleConstructorReturn3(self2, call) {
    if (call && (_typeof12(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized3(self2);
  }
  function _assertThisInitialized3(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf3(o) {
    _getPrototypeOf3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf3(o);
  }
  var _require, Request3, IMS, ImsAPI, _imsApi;
  var init_ims = __esm({
    "lib/apis/ims.js": function lib_apis_imsJs() {
      "use strict";

      init_managers();
      init_utils();
      _require = (init_core(), __toCommonJS(core_exports));
      Request3 = _require.Request;
      IMS = {
        SIGNIN_PLAYNOW_WITH_LOCAL_CREDENTIAL: "/playnow/signin/local"
      };
      ImsAPI = /* @__PURE__ */function (_Request) {
        _inherits3(ImsAPI2, _Request);
        var _super = _createSuper3(ImsAPI2);
        function ImsAPI2() {
          _classCallCheck9(this, ImsAPI2);
          return _super.apply(this, arguments);
        }
        _createClass9(ImsAPI2, [{
          key: "request",
          value: function request3(path, body, headers, options) {
            var url = "".concat(environmentManager.apiUrl.IMS_API_URL).concat(path);
            return _get3(_getPrototypeOf3(ImsAPI2.prototype), "request", this).call(this, url, body, headers, options);
          }
        }, {
          key: "signinWithLocalCredential",
          value: function () {
            var _signinWithLocalCredential = _asyncToGenerator5( /* @__PURE__ */_regeneratorRuntime5().mark(function _callee(_ref) {
              var gid, country, deviceId, playnowUid, localCredential, _ref$clientPlatform, clientPlatform, localCredentialHash, path, body;
              return _regeneratorRuntime5().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    gid = _ref.gid, country = _ref.country, deviceId = _ref.deviceId, playnowUid = _ref.playnowUid, localCredential = _ref.localCredential, _ref$clientPlatform = _ref.clientPlatform, clientPlatform = _ref$clientPlatform === void 0 ? "web" : _ref$clientPlatform;
                    _context.next = 3;
                    return hmacSha256(localCredential, atob("UExBWU5PV19TRUNSRVQ="));
                  case 3:
                    localCredentialHash = _context.sent;
                    path = IMS.SIGNIN_PLAYNOW_WITH_LOCAL_CREDENTIAL;
                    body = camelToSnakeForObject({
                      gid: gid,
                      country: country,
                      clientPlatform: clientPlatform,
                      deviceId: deviceId,
                      playnowUid: playnowUid,
                      localCredentialHash: localCredentialHash
                    });
                    return _context.abrupt("return", this.request(path, body, null, {
                      functionName: "signinWithLocalCredential"
                    }));
                  case 7:
                  case "end":
                    return _context.stop();
                }
              }, _callee, this);
            }));
            function signinWithLocalCredential(_x) {
              return _signinWithLocalCredential.apply(this, arguments);
            }
            return signinWithLocalCredential;
          }()
        }]);
        return ImsAPI2;
      }(Request3);
      _imsApi = new ImsAPI();
    }
  });

  // lib/apis/index.js
  var apis_exports = {};
  __export(apis_exports, {
    BOLT_ENUM: function BOLT_ENUM() {
      return _BOLT_ENUM;
    },
    BOLT_ERROR_CODE: function BOLT_ERROR_CODE() {
      return ERROR_CODE;
    },
    boltApi: function boltApi() {
      return _boltApi;
    },
    iasApi: function iasApi() {
      return _iasApi;
    },
    imsApi: function imsApi() {
      return _imsApi;
    }
  });
  var init_apis = __esm({
    "lib/apis/index.js": function lib_apis_indexJs() {
      "use strict";

      init_ias();
      init_bolt();
      init_ims();
    }
  });

  // lib/interface/sdk-api.interface.js
  function createSdkApis(instance2) {
    return {
      init: function init2() {
        return instance2.init.apply(instance2, arguments);
      },
      gotoSignUp: function gotoSignUp() {
        return instance2.gotoSignUp.apply(instance2, arguments);
      },
      gotoLogin: function gotoLogin() {
        return instance2.gotoLogin.apply(instance2, arguments);
      },
      gotoLogout: function gotoLogout() {
        return instance2.gotoLogout.apply(instance2, arguments);
      },
      showPlayNowCode: function showPlayNowCode() {
        return instance2.showPlayNowCode.apply(instance2, arguments);
      },
      showAccountSettings: function showAccountSettings() {
        return instance2.showAccountSettings.apply(instance2, arguments);
      },
      issueLaunchingToken: function issueLaunchingToken() {
        return instance2.issueLaunchingToken.apply(instance2, arguments);
      },
      saveGameTokenInfo: function saveGameTokenInfo() {
        return instance2.saveGameTokenInfo.apply(instance2, arguments);
      },
      getUserInfo: function getUserInfo() {
        return instance2.getUserInfo.apply(instance2, arguments);
      },
      /** SETTERs, GETTERs * */
      get gid() {
        return instance2.gid;
      },
      get env() {
        return instance2.env;
      },
      /** @returns {Promise<boolean>} */
      get isLogin() {
        return instance2.isLogin;
      },
      /** @returns {Promise<string>} */
      get gameToken() {
        return instance2.gameToken;
      },
      get guid() {
        return instance2.guid;
      },
      get webToken() {
        return instance2.webToken;
      },
      get localCredential() {
        return instance2.localCredential;
      },
      get accountType() {
        return instance2.accountType;
      }
    };
  }

  // lib/services/game-token.service.js
  init_apis();
  init_core();
  init_constants();
  init_managers();
  function _typeof13(obj) {
    "@babel/helpers - typeof";

    return _typeof13 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof13(obj);
  }
  function _regeneratorRuntime6() {
    "use strict";

    _regeneratorRuntime6 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof13(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof13(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep6(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator6(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep6(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep6(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck10(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties10(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey11(descriptor.key), descriptor);
    }
  }
  function _createClass10(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties10(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties10(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey11(arg) {
    var key = _toPrimitive11(arg, "string");
    return _typeof13(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive11(input, hint) {
    if (_typeof13(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof13(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var GT_VERIFY_RESULT = {
    EXPIRED: "EXPIRED",
    VERIFIED: "VERIFIED",
    UNEXPECTED: "UNEXPECTED"
  };
  var THROTTLE_TIME = 1e4;
  var GameTokenService = /* @__PURE__ */function () {
    function GameTokenService2() {
      _classCallCheck10(this, GameTokenService2);
      this.resetGtThrottle();
    }
    _createClass10(GameTokenService2, [{
      key: "init",
      value: function init2(gid) {
        this.gid = gid;
      }
    }, {
      key: "isTimeToVerify",
      value: function isTimeToVerify(gameToken) {
        if (this.verifyInfo.gameToken !== gameToken) return true;
        var time = this.verifyInfo.lastVerifiedTime;
        return time === 0 ? true : Date.now() - time > THROTTLE_TIME;
      }
    }, {
      key: "resetGtThrottle",
      value: function resetGtThrottle() {
        this.verifyInfo = {
          lastVerifiedTime: 0,
          gameToken: null
        };
      }
    }, {
      key: "renewGtThrottle",
      value: function renewGtThrottle(gameToken) {
        this.verifyInfo = {
          lastVerifiedTime: Date.now(),
          gameToken: gameToken
        };
      }
      /** @returns {InsignResponse} */
    }, {
      key: "issueGameToken",
      value: function () {
        var _issueGameToken = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee() {
          var _ref,
            _ref$gid,
            gid,
            guid,
            ticket,
            locale,
            _yield$iasApi$issueGa,
            success,
            data,
            error,
            gameToken,
            result,
            _args = arguments;
          return _regeneratorRuntime6().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, _ref$gid = _ref.gid, gid = _ref$gid === void 0 ? this.gid : _ref$gid, guid = _ref.guid, ticket = _ref.ticket, locale = _ref.locale;
                _context.next = 3;
                return _iasApi.issueGameTokenByTicket({
                  ticket: ticket,
                  locale: locale
                });
              case 3:
                _yield$iasApi$issueGa = _context.sent;
                success = _yield$iasApi$issueGa.success;
                data = _yield$iasApi$issueGa.data;
                error = _yield$iasApi$issueGa.error;
                if (!success) {
                  _context.next = 13;
                  break;
                }
                gameToken = data.gameToken;
                result = storeManager.putGameTokenInfo(gid, guid, gameToken);
                if (!result) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return", {
                  success: success,
                  data: data
                });
              case 12:
                return _context.abrupt("return", new _ResponseBuilder(false, {
                  functionName: "issueGameToken"
                }).error(error_code_enum_default.GAME_AUTH.SDK.CAN_NOT_SAVE_GAME_TOKEN).build());
              case 13:
                return _context.abrupt("return", {
                  success: success,
                  data: data,
                  error: error
                });
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function issueGameToken() {
          return _issueGameToken.apply(this, arguments);
        }
        return issueGameToken;
      }()
      /**
       * Game Token을 만료시키고 쿠키에서 제거 합니다.
       * @returns {Promise<boolean>} 쿠키에서 GameToken 삭제 성공했으면 true, 실패시 false
       */
    }, {
      key: "expireGameToken",
      value: function () {
        var _expireGameToken = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee2() {
          var gid,
            _storeManager$getGame,
            gameToken,
            _storeManager$getGame2,
            gt,
            _args2 = arguments;
          return _regeneratorRuntime6().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                gid = _args2.length > 0 && _args2[0] !== void 0 ? _args2[0] : this.gid;
                _storeManager$getGame = storeManager.getGameTokenInfo(gid), gameToken = _storeManager$getGame.gameToken;
                if (gameToken) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", true);
              case 4:
                storeManager.removeGameTokenInfo(gid);
                _context2.next = 7;
                return _iasApi.expireGameToken(gameToken);
              case 7:
                this.resetGtThrottle();
                _storeManager$getGame2 = storeManager.getGameTokenInfo(gid), gt = _storeManager$getGame2.gameToken;
                return _context2.abrupt("return", !gt);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function expireGameToken() {
          return _expireGameToken.apply(this, arguments);
        }
        return expireGameToken;
      }()
      /**
       * 게임 토큰을 검증하고 결과를 InsignResponse 형태로 반환하는 퍼블릭 메서드입니다.
       *
       * - 검증 API 호출이 성공하면 응답을 10초 동안 캐싱하여 불필요한 중복 호출을 방지합니다.
       * - 파라미터의 게임 토큰과 캐싱된 게임 토큰이 다를 경우 캐시가 초기화 또는 갱신됩니다.
       * - 성공 응답 값의 data 속성에는 verifyGameToken API의 응답 값이 그대로 담깁니다.
       *   -> gid, guid, uid, platformType, platformUserId, loginPlatform, npaCode
       * - 실패 응답의 경우 error 속성에 에러 코드가 담깁니다.
       *   -> ErrorCode.GAME_AUTH.SDK.INVALID_PARAMETER: 파라미터가 유효하지 않은 경우
       *   -> ErrorCode.GAME_AUTH.SDK.GAME_TOKEN_EXPIRED: 게임 토큰이 만료된 경우
       *   -> ErrorCode.GAME_AUTH.SDK.GAME_TOKEN_VERIFICATION_FAILED: 게임 토큰 검증에 실패한 경우
       *
       * @param {string} gameToken - 검증할 게임 토큰
       * @returns {Promise<InsignResponse>} 검증 결과
       */
    }, {
      key: "verifyGameToken",
      value: function () {
        var _verifyGameToken2 = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee3(gameToken) {
          var functionName, isSameGameToken, _this$cachedVerifyGam, response, success, data, error;
          return _regeneratorRuntime6().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                functionName = "verifyGameToken";
                if (gameToken) {
                  _context3.next = 3;
                  break;
                }
                return _context3.abrupt("return", new _ResponseBuilder(false, {
                  functionName: functionName
                }).error(error_code_enum_default.GAME_AUTH.SDK.INVALID_PARAMETER).build());
              case 3:
                isSameGameToken = this.verifyInfo.gameToken === gameToken;
                if (!(this.cachedVerifyGameTokenResponse && isSameGameToken && !this.isTimeToVerify(gameToken))) {
                  _context3.next = 8;
                  break;
                }
                if (!this.cachedVerifyGameTokenResponse.success) {
                  _context3.next = 7;
                  break;
                }
                return _context3.abrupt("return", new _ResponseBuilder(true, {
                  functionName: functionName
                }).data(this.cachedVerifyGameTokenResponse.data).build());
              case 7:
                return _context3.abrupt("return", new _ResponseBuilder(false, {
                  functionName: functionName
                }).error(this.cachedVerifyGameTokenResponse.error).errorRawResponseData((_this$cachedVerifyGam = this.cachedVerifyGameTokenResponse.error) === null || _this$cachedVerifyGam === void 0 ? void 0 : _this$cachedVerifyGam.rawResponseData).build());
              case 8:
                _context3.next = 10;
                return _iasApi.verifyGameToken(gameToken);
              case 10:
                response = _context3.sent;
                this.cachedVerifyGameTokenResponse = response;
                success = response.success, data = response.data, error = response.error;
                if (!success) {
                  _context3.next = 16;
                  break;
                }
                this.renewGtThrottle(gameToken);
                return _context3.abrupt("return", new _ResponseBuilder(true, {
                  functionName: functionName
                }).data(data).build());
              case 16:
                if (!("".concat(error.httpStatus) === "401")) {
                  _context3.next = 18;
                  break;
                }
                return _context3.abrupt("return", new _ResponseBuilder(false, {
                  functionName: functionName
                }).error(error_code_enum_default.GAME_AUTH.SDK.GAME_TOKEN_EXPIRED).errorRawResponseData(error.rawResponseData).build());
              case 18:
                this.cachedVerifyGameTokenResponse = null;
                return _context3.abrupt("return", new _ResponseBuilder(false, {
                  functionName: functionName
                }).error(error_code_enum_default.GAME_AUTH.SDK.GAME_TOKEN_VERIFICATION_FAILED).errorRawResponseData(error.rawResponseData).build());
              case 20:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function verifyGameToken(_x) {
          return _verifyGameToken2.apply(this, arguments);
        }
        return verifyGameToken;
      }()
      /**
       * Game Token 을 검증합니다. throttling: 1분
       */
    }, {
      key: "getVerifiedGameToken",
      value: function () {
        var _getVerifiedGameToken = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee4() {
          var gid,
            _yield$this$_getVerif,
            gameToken,
            _args4 = arguments;
          return _regeneratorRuntime6().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                gid = _args4.length > 0 && _args4[0] !== void 0 ? _args4[0] : this.gid;
                _context4.next = 3;
                return this._getVerifiedGameTokenInfo(gid);
              case 3:
                _yield$this$_getVerif = _context4.sent;
                gameToken = _yield$this$_getVerif.gameToken;
                return _context4.abrupt("return", gameToken);
              case 6:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function getVerifiedGameToken() {
          return _getVerifiedGameToken.apply(this, arguments);
        }
        return getVerifiedGameToken;
      }()
    }, {
      key: "getValidGuid",
      value: function () {
        var _getValidGuid = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee5() {
          var gid,
            _yield$this$_getVerif2,
            guid,
            _args5 = arguments;
          return _regeneratorRuntime6().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                gid = _args5.length > 0 && _args5[0] !== void 0 ? _args5[0] : this.gid;
                _context5.next = 3;
                return this._getVerifiedGameTokenInfo(gid);
              case 3:
                _yield$this$_getVerif2 = _context5.sent;
                guid = _yield$this$_getVerif2.guid;
                return _context5.abrupt("return", guid);
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function getValidGuid() {
          return _getValidGuid.apply(this, arguments);
        }
        return getValidGuid;
      }()
    }, {
      key: "getVerifiedGameTokenInfo",
      value: function getVerifiedGameTokenInfo() {
        var gid = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.gid;
        return this._getVerifiedGameTokenInfo(gid);
      }
      /**
       * @returns {{ token: string, accountType: string } | InsignError}
       */
    }, {
      key: "issueWebTokenByGameToken",
      value: function () {
        var _issueWebTokenByGameToken = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee6(gameToken) {
          var _ref2,
            _ref2$gid,
            gid,
            _yield$this$_getVerif3,
            cookieGT,
            _yield$iasApi$issueWe,
            success,
            data,
            error,
            webToken,
            localSessionType,
            _args6 = arguments;
          return _regeneratorRuntime6().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _ref2 = _args6.length > 1 && _args6[1] !== void 0 ? _args6[1] : {}, _ref2$gid = _ref2.gid, gid = _ref2$gid === void 0 ? this.gid : _ref2$gid;
                _context6.next = 3;
                return this._getVerifiedGameTokenInfo(gid);
              case 3:
                _yield$this$_getVerif3 = _context6.sent;
                cookieGT = _yield$this$_getVerif3.gameToken;
                _context6.next = 7;
                return _iasApi.issueWebTokenByGameToken(gameToken || cookieGT);
              case 7:
                _yield$iasApi$issueWe = _context6.sent;
                success = _yield$iasApi$issueWe.success;
                data = _yield$iasApi$issueWe.data;
                error = _yield$iasApi$issueWe.error;
                if (success) {
                  _context6.next = 13;
                  break;
                }
                return _context6.abrupt("return", {
                  error: error
                });
              case 13:
                webToken = data.webToken, localSessionType = data.localSessionType;
                return _context6.abrupt("return", {
                  token: webToken,
                  accountType: localSessionType
                });
              case 15:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function issueWebTokenByGameToken(_x2) {
          return _issueWebTokenByGameToken.apply(this, arguments);
        }
        return issueWebTokenByGameToken;
      }()
    }, {
      key: "_verifyGameToken",
      value: function () {
        var _verifyGameToken3 = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee7(gameToken) {
          var response, success, error;
          return _regeneratorRuntime6().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _iasApi.verifyGameToken(gameToken);
              case 2:
                response = _context7.sent;
                success = response.success, error = response.error;
                if (!success) {
                  _context7.next = 6;
                  break;
                }
                return _context7.abrupt("return", GT_VERIFY_RESULT.VERIFIED);
              case 6:
                if (!("".concat(error.httpStatus) === "401")) {
                  _context7.next = 8;
                  break;
                }
                return _context7.abrupt("return", GT_VERIFY_RESULT.EXPIRED);
              case 8:
                return _context7.abrupt("return", GT_VERIFY_RESULT.UNEXPECTED);
              case 9:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        function _verifyGameToken(_x3) {
          return _verifyGameToken3.apply(this, arguments);
        }
        return _verifyGameToken;
      }()
      /** @returns {Promise<{ guid, gameToken } | {}>} */
    }, {
      key: "_getVerifiedGameTokenInfo",
      value: function () {
        var _getVerifiedGameTokenInfo2 = _asyncToGenerator6( /* @__PURE__ */_regeneratorRuntime6().mark(function _callee8() {
          var gid,
            _storeManager$getGame3,
            gameToken,
            guid,
            result,
            _args8 = arguments;
          return _regeneratorRuntime6().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                gid = _args8.length > 0 && _args8[0] !== void 0 ? _args8[0] : this.gid;
                _storeManager$getGame3 = storeManager.getGameTokenInfo(gid), gameToken = _storeManager$getGame3.gameToken, guid = _storeManager$getGame3.guid;
                if (!(!gameToken || !guid)) {
                  _context8.next = 4;
                  break;
                }
                return _context8.abrupt("return", {});
              case 4:
                if (this.isTimeToVerify(gameToken)) {
                  _context8.next = 6;
                  break;
                }
                return _context8.abrupt("return", {
                  gameToken: gameToken,
                  guid: guid
                });
              case 6:
                _context8.next = 8;
                return this._verifyGameToken(gameToken);
              case 8:
                result = _context8.sent;
                if (!(result === GT_VERIFY_RESULT.EXPIRED)) {
                  _context8.next = 13;
                  break;
                }
                storeManager.removeGameTokenInfo(gid);
                this.resetGtThrottle();
                return _context8.abrupt("return", {});
              case 13:
                if (result === GT_VERIFY_RESULT.VERIFIED) {
                  this.renewGtThrottle(gameToken);
                }
                return _context8.abrupt("return", {
                  gameToken: gameToken,
                  guid: guid
                });
              case 15:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function _getVerifiedGameTokenInfo() {
          return _getVerifiedGameTokenInfo2.apply(this, arguments);
        }
        return _getVerifiedGameTokenInfo;
      }()
    }]);
    return GameTokenService2;
  }();
  var gameTokenService = new GameTokenService();

  // lib/services/toy-terms.service.js
  init_apis();
  init_managers();

  // lib/services/environment.service.js
  init_managers();

  // lib/services/inface.service.js
  function _typeof14(obj) {
    "@babel/helpers - typeof";

    return _typeof14 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof14(obj);
  }
  function ownKeys4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread4(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys4(Object(source), true).forEach(function (key) {
        _defineProperty4(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty4(obj, key, value) {
    key = _toPropertyKey12(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _classCallCheck11(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties11(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey12(descriptor.key), descriptor);
    }
  }
  function _createClass11(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties11(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties11(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey12(arg) {
    var key = _toPrimitive12(arg, "string");
    return _typeof14(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive12(input, hint) {
    if (_typeof14(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof14(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var singleton = Symbol("property of instance");
  var singletonEnforcer = Symbol("to verify singleton");
  var INFACE_EVENT_TYPE = {
    TOY_WEB_SDK_MODULE: "toy-web-sdk:module",
    // 3rd sdks 간에 주고 받는 event 로 대외공개하지 않습니다.
    TOY_WEB_SDK_EVENT: "toy-web-sdk:event"
    // 외부에 공개하는 이벤트 ex: game-token 생성, gameAuth 초기화 완료 등
  };
  var INFACE_META_NAME = {
    INFACE_GID: "inface-gid",
    INFACE_ENV: "inface-env"
  };
  var SDK_STATUS = {
    INITIALIZED: "initialized",
    PREPARING: "preparing",
    FINALIZED: "finalized"
  };
  var InfaceService = /* @__PURE__ */function () {
    function InfaceService2(enforcer) {
      var _this = this;
      _classCallCheck11(this, InfaceService2);
      if (enforcer !== singletonEnforcer) {
        throw new Error("You are supposed to use InfaceService as singleton");
      }
      this._eventListeners = {};
      window.addEventListener(INFACE_EVENT_TYPE.TOY_WEB_SDK_MODULE,
      /**
       *
       * @param {ToyWebSdkEvent} event
       */
      function (event) {
        var _ref = (event === null || event === void 0 ? void 0 : event.detail) || {},
          moduleName = _ref.moduleName,
          eventData = _ref.eventData;
        var callbacks = _this._eventListeners[INFACE_EVENT_TYPE.TOY_WEB_SDK_MODULE];
        if (!Array.isArray(callbacks)) return;
        callbacks.forEach(function (callback) {
          if (typeof callback === "function") callback({
            moduleName: moduleName,
            eventData: eventData
          });
        });
      });
    }
    _createClass11(InfaceService2, [{
      key: "moduleName",
      get: function get() {
        return this._moduleName;
      }
      /**
       *  TOY Web SDK 의 meta tag 들을 반환합니다.
       *
       * - TOY Web SDK v2 정책: <meta name="" content="">
       * - TOY Web SDK v3 정책: <meta type="inface" module="${module}" ...>
       *
       * v3 부터는 각 module 에서 임의로 meta element 의 attribute 를 정의합니다.
       * 정책 변경에 따라 반환값은 다음과 같습니다.
       *
       * 1. v2 에서 사용한 메타 태그
       *  - infaceMetas.v2 object 에 { name: content } 형태로 포함됩니다.
       *  - 'inface-gid' property 는 필수로 포함되어야 합니다.
       * 2. v3 부터 적용하는 메타 태그
       *  - type, module attribute 외에는 module 별 선언이라 meta tag DOM 을 반환합니다.
       *  - module 별 여러개의 meta 를 활용 할 수 있어서 array 형태( moduleName: [] )로 반환합니다.
       *
       * @returns {{ v2: { [name: string]: string }, [moduleName: string]: [] } }}
       */
    }, {
      key: "infaceMetas",
      get: function get() {
        var metas = Array.from(document.querySelectorAll('meta[type="inface"]')).reduce(function (obj, meta) {
          var moduleName = meta.getAttribute("module");
          if (!moduleName) return obj;
          if (!obj[moduleName]) obj[moduleName] = [];
          obj[moduleName].push(meta);
          return obj;
        }, {});
        var oldMetaObj = Array.from(document.querySelectorAll('meta[name^="inface"]')).reduce(function (obj, meta) {
          obj[meta.name] = meta.content;
          return obj;
        }, {});
        metas.v2 = oldMetaObj;
        return metas;
      }
    }, {
      key: "setModuleName",
      value: function setModuleName(moduleName) {
        this._moduleName = moduleName;
      }
      /**
       * @param {INFACE_EVENT_TYPE} eventType
       */
    }, {
      key: "addEventListener",
      value: function addEventListener(eventType, callback) {
        if (typeof callback !== "function") return;
        if (!Array.isArray(this._eventListeners[eventType])) this._eventListeners[eventType] = [];
        var listeners = this._eventListeners[eventType];
        if (listeners.some(function (listener) {
          return listener === callback;
        })) {
          return;
        }
        this._eventListeners[eventType].push(callback);
      }
      /**
       *  TOY Web SDK 의 각 SDK 들의 lifecycle 변경에 따른 이벤트 전파입니다.
       * preparing -> initialized -> finalized 순서로 변경 됩니다.
       * - preparing: SDK 의 main class 가 생성된 상태입니다.
       * - initialized: SDK 의 초기화 비즈니스 로직이 완료 되어 사용 준비가 완료 된 상태입니다.
       * - finalized: SDK lifecycle 이 종료 된 상태입니다. 재사용하기 위해서는 SDK 초기화를 다시해야 합니다.
       *
       * event format
       * { type: 'lifecycle', data: { status: 'preparing'|'initialized'|'finalized' } }
       * @param {object} params
       * @param {string} params.moduleName
       * @param {string} params.status
       * @param {object} params.additionalData - status 와 동일 depth 에 추가되어 전달될 추가 data
       */
    }, {
      key: "sendStatusChangeEvent",
      value: function sendStatusChangeEvent(_ref2) {
        var _ref2$moduleName = _ref2.moduleName,
          moduleName = _ref2$moduleName === void 0 ? this.moduleName : _ref2$moduleName,
          _ref2$status = _ref2.status,
          status = _ref2$status === void 0 ? SDK_STATUS.INITIALIZED : _ref2$status,
          additionalData = _ref2.additionalData;
        var eventData = {
          type: "lifecycle",
          data: _objectSpread4(_objectSpread4({}, additionalData), {}, {
            status: status
          })
        };
        this.sendModuleEvent({
          moduleName: moduleName,
          eventData: eventData
        });
        this.sendSdkEvent({
          moduleName: moduleName,
          eventData: eventData
        });
      }
      /**
       *  TOY Web SDK 모듈간에 주고받을 Event 로 외부로 공개하지 않는 이벤트입니다.
       * dependency 가 걸리는 모듈이 이벤트를 통해 활용 할 수 있습니다.
       *
       * ex) web-push 가 web-auth 초기화 완료 시점에 web-auth lifecycle initialized 이벤트를 수신 한 후,
       * 유저의 로그인 여부를 파악해서 livestream 세션을 생성 할 수 있음
       *
       * @param {ToyWebSdkEvent} obj
       */
    }, {
      key: "sendModuleEvent",
      value: function sendModuleEvent(_ref3) {
        var _ref3$moduleName = _ref3.moduleName,
          moduleName = _ref3$moduleName === void 0 ? this.moduleName : _ref3$moduleName,
          eventData = _ref3.eventData;
        window.dispatchEvent(new CustomEvent(INFACE_EVENT_TYPE.TOY_WEB_SDK_MODULE, {
          detail: {
            moduleName: moduleName,
            eventData: eventData
          }
        }));
      }
      /**
       *  TOY Web SDK 를 사용하는 곳에 전달할 일반 이벤트 입니다.
       *
       * ex) 웹게임에서 유저가 로그아웃 되는 경우 game-auth 로 부터 로그아웃 이벤트를 받아 비로그인 상태로 변경 할 수 있음
       *
       * @param {ToyWebSdkEvent}
       */
    }, {
      key: "sendSdkEvent",
      value: function sendSdkEvent(_ref4) {
        var _ref4$moduleName = _ref4.moduleName,
          moduleName = _ref4$moduleName === void 0 ? this.moduleName : _ref4$moduleName,
          eventData = _ref4.eventData;
        window.dispatchEvent(new CustomEvent(INFACE_EVENT_TYPE.TOY_WEB_SDK_EVENT, {
          detail: {
            moduleName: moduleName,
            eventData: eventData
          }
        }));
      }
    }], [{
      key: "instance",
      get: ( /** @returns {InfaceService} */
      function get() {
        if (!this[singleton]) this[singleton] = new InfaceService2(singletonEnforcer);
        return this[singleton];
      })
    }]);
    return InfaceService2;
  }();

  // lib/services/environment.service.js
  function _typeof15(obj) {
    "@babel/helpers - typeof";

    return _typeof15 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof15(obj);
  }
  function _slicedToArray2(arr, i) {
    return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
  }
  function _nonIterableRest2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen);
  }
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit2(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = true,
        _d = false;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = false;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = true);
      } catch (err) {
        _d = true, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles2(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _classCallCheck12(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties12(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey13(descriptor.key), descriptor);
    }
  }
  function _createClass12(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties12(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties12(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey13(arg) {
    var key = _toPrimitive13(arg, "string");
    return _typeof15(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive13(input, hint) {
    if (_typeof15(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof15(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var EnvironmentService = /* @__PURE__ */function () {
    function EnvironmentService2() {
      _classCallCheck12(this, EnvironmentService2);
    }
    _createClass12(EnvironmentService2, [{
      key: "insignBaseUrl",
      get: function get() {
        return environmentManager.apiUrl.INSIGN_BASE_URL;
      }
      /**
       *  INSIGN 에서 사용하는 여러 값들을 다룹니다.
       * @param {object} params
       * @param {string} env - full env 또는 2 characters env
       * @returns {string} full env
       */
    }, {
      key: "setEnvironment",
      value: function setEnvironment() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          gid = _ref.gid,
          env = _ref.env,
          locale = _ref.locale,
          country = _ref.country;
        if (!gid) {
          return;
        }
        var metas = this._parseMetaTags();
        this.gid = gid || metas.gid;
        this.locale = locale || navigator.language || "";
        this.country = country || storeManager.selectorCountry;
        this.playnow = metas.playnow || false;
        this.env = environmentManager.setEnvironment(env || metas.env || "live");
        return this.env;
      }
    }, {
      key: "_parseMetaTags",
      value: function _parseMetaTags() {
        var metas = InfaceService.instance.infaceMetas;
        var result = {};
        for (var _i = 0, _Object$entries = Object.entries(metas.v2); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray2(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          if (key === "inface-env") result.env = value;
          if (key === "inface-gid") result.gid = value;
        }
        if (metas["game-auth"]) {
          var meta = metas["game-auth"].find(function (m) {
            return m.hasAttribute("playnow");
          });
          if (meta) {
            var _value = meta.getAttribute("playnow");
            result.playnow = _value === "on";
          }
        }
        return result;
      }
    }]);
    return EnvironmentService2;
  }();
  var environmentService = new EnvironmentService();

  // node_modules/uuid/dist/esm-browser/rng.js
  var getRandomValues;
  var rnds8 = new Uint8Array(16);
  function rng() {
    if (!getRandomValues) {
      getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
      if (!getRandomValues) {
        throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      }
    }
    return getRandomValues(rnds8);
  }

  // node_modules/uuid/dist/esm-browser/stringify.js
  var byteToHex = [];
  for (i = 0; i < 256; ++i) {
    byteToHex.push((i + 256).toString(16).slice(1));
  }
  var i;
  function unsafeStringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  }

  // node_modules/uuid/dist/esm-browser/native.js
  var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
  var native_default = {
    randomUUID: randomUUID
  };

  // node_modules/uuid/dist/esm-browser/v4.js
  function v4(options, buf, offset) {
    if (native_default.randomUUID && !buf && !options) {
      return native_default.randomUUID();
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    rnds[6] = rnds[6] & 15 | 64;
    rnds[8] = rnds[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = rnds[i];
      }
      return buf;
    }
    return unsafeStringify(rnds);
  }
  var v4_default = v4;

  // lib/services/persistence.service.js
  init_constants();
  init_managers();
  init_utils();
  function _typeof16(obj) {
    "@babel/helpers - typeof";

    return _typeof16 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof16(obj);
  }
  function _regeneratorRuntime7() {
    "use strict";

    _regeneratorRuntime7 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof16(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof16(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep7(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator7(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep7(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep7(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck13(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties13(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey14(descriptor.key), descriptor);
    }
  }
  function _createClass13(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties13(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties13(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey14(arg) {
    var key = _toPrimitive14(arg, "string");
    return _typeof16(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive14(input, hint) {
    if (_typeof16(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof16(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var PersistenceService = /* @__PURE__ */function () {
    function PersistenceService2() {
      _classCallCheck13(this, PersistenceService2);
    }
    _createClass13(PersistenceService2, [{
      key: "_getUuidLS",
      value: function _getUuidLS() {
        var uuid = localStorage.getItem(LOCAL_STORAGE.TOY_WEB_SDK.UUID);
        if (uuid) {
          try {
            return decrypt(uuid);
          } catch (error) {}
        }
      }
    }, {
      key: "_setUuidLS",
      value: function _setUuidLS(uuid) {
        localStorage.setItem(LOCAL_STORAGE.TOY_WEB_SDK.UUID, encrypt(uuid));
      }
    }, {
      key: "_getUuidCookie",
      value: function _getUuidCookie() {
        return storeManager.getGAMetaData(SDK_COOKIE.UUID);
      }
    }, {
      key: "_setUuidCookie",
      value: function _setUuidCookie(uuid) {
        storeManager.putGAMetaData(SDK_COOKIE.UUID, uuid);
      }
    }, {
      key: "insignPage",
      get: function get() {
        return window.location.host.includes("signin.nexon.com");
      }
    }, {
      key: "syncedUuid",
      value: function () {
        var _syncedUuid = _asyncToGenerator7( /* @__PURE__ */_regeneratorRuntime7().mark(function _callee() {
          var _ref,
            _ref$initializePhase,
            initializePhase,
            lsUuid,
            ckUuid,
            uuid,
            _uuid,
            eventData,
            _args = arguments;
          return _regeneratorRuntime7().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, _ref$initializePhase = _ref.initializePhase, initializePhase = _ref$initializePhase === void 0 ? false : _ref$initializePhase;
                lsUuid = this._getUuidLS();
                ckUuid = this._getUuidCookie();
                if (!(lsUuid && ckUuid && lsUuid === ckUuid)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", lsUuid);
              case 5:
                if (!(!lsUuid && !ckUuid)) {
                  _context.next = 12;
                  break;
                }
                if (!(initializePhase && !this.insignPage)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                uuid = v4_default();
                this._setUuidLS(uuid);
                this._setUuidCookie(uuid);
                return _context.abrupt("return", uuid);
              case 12:
                if (!(!lsUuid && ckUuid || lsUuid && !ckUuid)) {
                  _context.next = 15;
                  break;
                }
                if (lsUuid) {
                  this._setUuidCookie(lsUuid);
                } else {
                  this._setUuidLS(ckUuid);
                }
                return _context.abrupt("return", lsUuid || ckUuid);
              case 15:
                console.warn("[web-game-auth] CASE 3. DIFFERENT LS[".concat(lsUuid, "] Cookie[").concat(ckUuid, "] insign[").concat(this.insignPage, "]"));
                if (this.insignPage) {
                  this._setUuidCookie(lsUuid);
                } else {
                  console.warn("UUID : LS vs CK \uAC00 \uBD88\uC77C\uCE58\uD558\uB294 \uC0C1\uD669\uC785\uB2C8\uB2E4. PN \uC0C1\uD0DC\uC77C \uACBD\uC6B0 LC \uC640 pair\uAC00 \uB418\uB294 UUID \uB97C \uC704\uD574 \uAC80\uC99D \uD6C4 \uC77C\uCE58 \uC2DC\uCF1C\uC57C \uD569\uB2C8\uB2E4.");
                  _uuid = lsUuid;
                  eventData = {
                    type: SDK_EVENT_TYPE.UUID,
                    data: {
                      uuid: _uuid
                    }
                  };
                  InfaceService.instance.sendSdkEvent({
                    eventData: eventData
                  });
                }
                return _context.abrupt("return", lsUuid);
              case 18:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function syncedUuid() {
          return _syncedUuid.apply(this, arguments);
        }
        return syncedUuid;
      }()
    }]);
    return PersistenceService2;
  }();
  var persistenceService = new PersistenceService();

  // lib/services/toy-terms.service.js
  function _typeof17(obj) {
    "@babel/helpers - typeof";

    return _typeof17 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof17(obj);
  }
  function _regeneratorRuntime8() {
    "use strict";

    _regeneratorRuntime8 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof17(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof17(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep8(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator8(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep8(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep8(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck14(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties14(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey15(descriptor.key), descriptor);
    }
  }
  function _createClass14(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties14(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties14(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey15(arg) {
    var key = _toPrimitive15(arg, "string");
    return _typeof17(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive15(input, hint) {
    if (_typeof17(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof17(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var TERMS = {
    NEED_TO_AGREE: 0,
    AGREE: 1,
    NOT_AGREE: 2
  };
  var ToyTermsService = /* @__PURE__ */function () {
    function ToyTermsService2() {
      _classCallCheck14(this, ToyTermsService2);
    }
    _createClass14(ToyTermsService2, [{
      key: "init",
      value: function init2(gid) {
        this.gid = gid;
      }
    }, {
      key: "_filterTermsToAgree",
      value: function _filterTermsToAgree() {
        var termsAgree = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!Array.isArray(termsAgree)) return [];
        return termsAgree.filter(function (terms) {
          return "".concat(terms.isAgree) === "".concat(TERMS.NEED_TO_AGREE);
        });
      }
      /**
       *  BOLT 로그인을 하지 않고, TOY 약관을 받아 옵니다.
       *  Game Token 만료나 GUID 오류 발생 시 쿠키에서 제거 합니다.
       * @returns {{ success: boolean, error, data: { termsAgree: [], memType: number } }}
       */
    }, {
      key: "getTermsByGameToken",
      value: function () {
        var _getTermsByGameToken = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee() {
          var gid, _yield$gameTokenServi, guid, gameToken, _yield$boltApi$termsB, success, data, error, _error$rawResponseDat, rawResponseData, errorCode, termsAgree, memType;
          return _regeneratorRuntime8().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                gid = this.gid;
                _context.next = 3;
                return gameTokenService.getVerifiedGameTokenInfo(gid);
              case 3:
                _yield$gameTokenServi = _context.sent;
                guid = _yield$gameTokenServi.guid;
                gameToken = _yield$gameTokenServi.gameToken;
                if (!(!gameToken || !guid)) {
                  _context.next = 9;
                  break;
                }
                console.warn("gid \uB85C gameToken \uAC80\uC0C9 \uC548 \uB3FC\uC11C \uC870\uAC74 \uCDA9\uC871 \uC548\uD55C \uC5D0\uB7EC \uBC1C\uC0DD\uC2DC\uCF1C\uC57C \uD568");
                return _context.abrupt("return", {
                  success: false
                });
              case 9:
                _context.next = 11;
                return _boltApi.termsByGameTokenNx({
                  gid: gid,
                  guid: guid,
                  gameToken: gameToken
                });
              case 11:
                _yield$boltApi$termsB = _context.sent;
                success = _yield$boltApi$termsB.success;
                data = _yield$boltApi$termsB.data;
                error = _yield$boltApi$termsB.error;
                if (success) {
                  _context.next = 20;
                  break;
                }
                _error$rawResponseDat = error.rawResponseData, rawResponseData = _error$rawResponseDat === void 0 ? {} : _error$rawResponseDat;
                errorCode = rawResponseData.errorCode;
                if ([ERROR_CODE.INVALID_GAME_TOKEN, ERROR_CODE.INVALID_GUID].includes(errorCode)) {
                  storeManager.removeGameTokenInfo(gid);
                }
                return _context.abrupt("return", {
                  success: success,
                  error: error
                });
              case 20:
                termsAgree = data.termsAgree, memType = data.memType;
                return _context.abrupt("return", {
                  success: true,
                  data: {
                    termsAgree: this._filterTermsToAgree(termsAgree),
                    memType: memType
                  }
                });
              case 22:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function getTermsByGameToken() {
          return _getTermsByGameToken.apply(this, arguments);
        }
        return getTermsByGameToken;
      }()
      /**
       *  BOLT 로그인을 하고 약관, 티켓, GUID 를 받아 옵니다.
       * @returns {{ success: boolean, error, data: { ticket: string, guid: string, termsAgree: [] } }}
       */
    }, {
      key: "getTermsWithWebToken",
      value: function () {
        var _getTermsWithWebToken = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee2(webToken) {
          var _ref,
            locale,
            deviceId,
            guidToLink,
            _ref$os,
            os,
            gid,
            uuid,
            params,
            gameToken,
            _yield$boltApi$signIn,
            success,
            data,
            error,
            _ref2,
            guid,
            termsAgree,
            ticket,
            _args2 = arguments;
          return _regeneratorRuntime8().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 1 && _args2[1] !== void 0 ? _args2[1] : {}, locale = _ref.locale, deviceId = _ref.uuid, guidToLink = _ref.guid, _ref$os = _ref.os, os = _ref$os === void 0 ? "desktop" : _ref$os;
                gid = this.gid;
                _context2.t0 = deviceId;
                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }
                _context2.next = 6;
                return persistenceService.syncedUuid();
              case 6:
                _context2.t0 = _context2.sent;
              case 7:
                uuid = _context2.t0;
                params = {
                  gid: gid,
                  webToken: webToken || storeManager.webToken,
                  os: os,
                  locale: locale,
                  uuid: uuid
                };
                if (!guidToLink) {
                  _context2.next = 14;
                  break;
                }
                _context2.next = 12;
                return gameTokenService.getVerifiedGameToken();
              case 12:
                gameToken = _context2.sent;
                if (gameToken) {
                  params.guid = guidToLink;
                  params.gameToken = gameToken;
                }
              case 14:
                _context2.next = 16;
                return _boltApi.signInWithWebTokenNx(params);
              case 16:
                _yield$boltApi$signIn = _context2.sent;
                success = _yield$boltApi$signIn.success;
                data = _yield$boltApi$signIn.data;
                error = _yield$boltApi$signIn.error;
                if (success) {
                  _context2.next = 22;
                  break;
                }
                return _context2.abrupt("return", {
                  success: success,
                  error: error
                });
              case 22:
                _ref2 = data || {}, guid = _ref2.guid, termsAgree = _ref2.termsAgree, ticket = _ref2.iasTicket;
                return _context2.abrupt("return", {
                  success: success,
                  data: {
                    guid: guid,
                    termsAgree: this._filterTermsToAgree(termsAgree),
                    ticket: ticket
                  }
                });
              case 24:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function getTermsWithWebToken(_x) {
          return _getTermsWithWebToken.apply(this, arguments);
        }
        return getTermsWithWebToken;
      }()
      /**
       *  BOLT 로그인을 하고 약관, 티켓, GUID 를 받아 옵니다.
       * @returns {{ success: boolean, error, data: { ticket: string, guid: string, termsAgree: [] }}}
       */
    }, {
      key: "getTermsWithLocalCredential",
      value: function () {
        var _getTermsWithLocalCredential = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee3() {
          var _ref3,
            uuid,
            locale,
            country,
            _ref3$clientPlatform,
            clientPlatform,
            gid,
            _storeManager$getLoca,
            localCredential,
            playnowUid,
            deviceId,
            _yield$imsApi$signinW,
            success,
            data,
            error,
            _data,
            ticket,
            _yield$boltApi$signIn2,
            _ref4,
            guid,
            termsAgree,
            _args3 = arguments;
          return _regeneratorRuntime8().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _ref3 = _args3.length > 0 && _args3[0] !== void 0 ? _args3[0] : {}, uuid = _ref3.uuid, locale = _ref3.locale, country = _ref3.country, _ref3$clientPlatform = _ref3.clientPlatform, clientPlatform = _ref3$clientPlatform === void 0 ? "web" : _ref3$clientPlatform;
                gid = this.gid;
                _storeManager$getLoca = storeManager.getLocalCredentialInfo(gid), localCredential = _storeManager$getLoca.localCredentialID, playnowUid = _storeManager$getLoca.playNowUserID;
                _context3.t0 = uuid;
                if (_context3.t0) {
                  _context3.next = 8;
                  break;
                }
                _context3.next = 7;
                return persistenceService.syncedUuid();
              case 7:
                _context3.t0 = _context3.sent;
              case 8:
                deviceId = _context3.t0;
                _context3.next = 11;
                return _imsApi.signinWithLocalCredential({
                  gid: gid,
                  country: country || environmentService.country,
                  clientPlatform: clientPlatform,
                  deviceId: deviceId,
                  localCredential: localCredential,
                  playnowUid: playnowUid
                });
              case 11:
                _yield$imsApi$signinW = _context3.sent;
                success = _yield$imsApi$signinW.success;
                data = _yield$imsApi$signinW.data;
                error = _yield$imsApi$signinW.error;
                if (success) {
                  _context3.next = 17;
                  break;
                }
                return _context3.abrupt("return", {
                  success: success,
                  error: error
                });
              case 17:
                _data = data, ticket = _data.ticket;
                _context3.next = 20;
                return _boltApi.signInWithTicketNx({
                  ticket: ticket,
                  uuid: deviceId,
                  locale: locale
                });
              case 20:
                _yield$boltApi$signIn2 = _context3.sent;
                success = _yield$boltApi$signIn2.success;
                data = _yield$boltApi$signIn2.data;
                error = _yield$boltApi$signIn2.error;
                if (success) {
                  _context3.next = 26;
                  break;
                }
                return _context3.abrupt("return", {
                  success: success,
                  error: error
                });
              case 26:
                _ref4 = data || {}, guid = _ref4.guid, termsAgree = _ref4.termsAgree;
                return _context3.abrupt("return", {
                  success: success,
                  data: {
                    guid: guid,
                    termsAgree: this._filterTermsToAgree(termsAgree),
                    ticket: ticket
                  }
                });
              case 28:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function getTermsWithLocalCredential() {
          return _getTermsWithLocalCredential.apply(this, arguments);
        }
        return getTermsWithLocalCredential;
      }()
    }, {
      key: "getTermsWithTicket",
      value: function () {
        var _getTermsWithTicket = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee4(ticket) {
          var _ref5,
            deviceId,
            locale,
            uuid,
            _yield$boltApi$signIn3,
            success,
            data,
            error,
            _ref6,
            guid,
            termsAgree,
            _args4 = arguments;
          return _regeneratorRuntime8().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _ref5 = _args4.length > 1 && _args4[1] !== void 0 ? _args4[1] : {}, deviceId = _ref5.uuid, locale = _ref5.locale;
                _context4.t0 = deviceId;
                if (_context4.t0) {
                  _context4.next = 6;
                  break;
                }
                _context4.next = 5;
                return persistenceService.syncedUuid();
              case 5:
                _context4.t0 = _context4.sent;
              case 6:
                uuid = _context4.t0;
                _context4.next = 9;
                return _boltApi.signInWithTicketNx({
                  ticket: ticket,
                  uuid: uuid,
                  locale: locale
                });
              case 9:
                _yield$boltApi$signIn3 = _context4.sent;
                success = _yield$boltApi$signIn3.success;
                data = _yield$boltApi$signIn3.data;
                error = _yield$boltApi$signIn3.error;
                if (success) {
                  _context4.next = 15;
                  break;
                }
                return _context4.abrupt("return", {
                  success: success,
                  error: error
                });
              case 15:
                _ref6 = data || {}, guid = _ref6.guid, termsAgree = _ref6.termsAgree;
                return _context4.abrupt("return", {
                  success: success,
                  data: {
                    guid: guid,
                    termsAgree: this._filterTermsToAgree(termsAgree),
                    ticket: ticket
                  }
                });
              case 17:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function getTermsWithTicket(_x2) {
          return _getTermsWithTicket.apply(this, arguments);
        }
        return getTermsWithTicket;
      }()
      /**
       *  BOLT 로그인을 하지 않고, 약관과 memType 을 받아 옵니다.
       * @returns {{ success: boolean, error, data: { memType: number, termsAgree: [] } }}
       */
    }, {
      key: "getTermsByTicket",
      value: function () {
        var _getTermsByTicket = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee5(guid, ticket) {
          var _ref7,
            os,
            gid,
            _yield$boltApi$termsB2,
            success,
            data,
            error,
            memType,
            termsAgree,
            _args5 = arguments;
          return _regeneratorRuntime8().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _ref7 = _args5.length > 2 && _args5[2] !== void 0 ? _args5[2] : {}, os = _ref7.os;
                gid = this.gid;
                _context5.next = 4;
                return _boltApi.termsByTicket({
                  gid: gid,
                  guid: guid,
                  ticket: ticket,
                  os: os
                });
              case 4:
                _yield$boltApi$termsB2 = _context5.sent;
                success = _yield$boltApi$termsB2.success;
                data = _yield$boltApi$termsB2.data;
                error = _yield$boltApi$termsB2.error;
                if (success) {
                  _context5.next = 10;
                  break;
                }
                return _context5.abrupt("return", {
                  success: success,
                  error: error
                });
              case 10:
                memType = data.memType, termsAgree = data.termsAgree;
                return _context5.abrupt("return", {
                  success: success,
                  data: {
                    memType: memType,
                    termsAgree: this._filterTermsToAgree(termsAgree)
                  }
                });
              case 12:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function getTermsByTicket(_x3, _x4) {
          return _getTermsByTicket.apply(this, arguments);
        }
        return getTermsByTicket;
      }()
    }, {
      key: "agreeTermsWithTicket",
      value: function () {
        var _agreeTermsWithTicket = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee6() {
          var _ref8,
            ticket,
            terms,
            deviceId,
            uuid,
            _args6 = arguments;
          return _regeneratorRuntime8().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _ref8 = _args6.length > 0 && _args6[0] !== void 0 ? _args6[0] : {}, ticket = _ref8.ticket, terms = _ref8.terms, deviceId = _ref8.uuid;
                _context6.t0 = deviceId;
                if (_context6.t0) {
                  _context6.next = 6;
                  break;
                }
                _context6.next = 5;
                return persistenceService.syncedUuid();
              case 5:
                _context6.t0 = _context6.sent;
              case 6:
                uuid = _context6.t0;
                return _context6.abrupt("return", _boltApi.agreeTermsWithTicketNx({
                  ticket: ticket,
                  uuid: uuid,
                  terms: terms
                }));
              case 8:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function agreeTermsWithTicket() {
          return _agreeTermsWithTicket.apply(this, arguments);
        }
        return agreeTermsWithTicket;
      }()
      /**
       *
       * @param {terms[]} terms
       * @param {*} param1
       */
    }, {
      key: "agreeTermsWithGameToken",
      value: function () {
        var _agreeTermsWithGameToken = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee7(terms) {
          var _ref9,
            paramGt,
            paramGuid,
            deviceId,
            locale,
            os,
            gid,
            uuid,
            _yield$gameTokenServi2,
            guid,
            gameToken,
            _args7 = arguments;
          return _regeneratorRuntime8().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _ref9 = _args7.length > 1 && _args7[1] !== void 0 ? _args7[1] : {}, paramGt = _ref9.gameToken, paramGuid = _ref9.guid, deviceId = _ref9.uuid, locale = _ref9.locale, os = _ref9.os;
                gid = this.gid;
                _context7.t0 = deviceId;
                if (_context7.t0) {
                  _context7.next = 7;
                  break;
                }
                _context7.next = 6;
                return persistenceService.syncedUuid();
              case 6:
                _context7.t0 = _context7.sent;
              case 7:
                uuid = _context7.t0;
                _context7.next = 10;
                return gameTokenService.getVerifiedGameTokenInfo(gid);
              case 10:
                _yield$gameTokenServi2 = _context7.sent;
                guid = _yield$gameTokenServi2.guid;
                gameToken = _yield$gameTokenServi2.gameToken;
                return _context7.abrupt("return", _boltApi.agreeTermsNx({
                  terms: terms,
                  gid: gid,
                  gameToken: paramGt || gameToken,
                  guid: paramGuid || guid,
                  uuid: uuid,
                  locale: locale,
                  os: os
                }));
              case 14:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function agreeTermsWithGameToken(_x5) {
          return _agreeTermsWithGameToken.apply(this, arguments);
        }
        return agreeTermsWithGameToken;
      }()
    }, {
      key: "reactivateAccountWithNpaCode",
      value: function () {
        var _reactivateAccountWithNpaCode = _asyncToGenerator8( /* @__PURE__ */_regeneratorRuntime8().mark(function _callee8(_ref10) {
          var memberId, memberType, npaCode, gid;
          return _regeneratorRuntime8().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                memberId = _ref10.memberId, memberType = _ref10.memberType, npaCode = _ref10.npaCode;
                gid = this.gid;
                return _context8.abrupt("return", _boltApi.reactivateAccount({
                  gid: gid,
                  memberId: memberId,
                  memberType: memberType,
                  npaCode: npaCode
                }));
              case 3:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function reactivateAccountWithNpaCode(_x6) {
          return _reactivateAccountWithNpaCode.apply(this, arguments);
        }
        return reactivateAccountWithNpaCode;
      }()
    }]);
    return ToyTermsService2;
  }();
  var toyTermsService = new ToyTermsService();

  // lib/services/insign.service.js
  init_apis();
  init_constants();
  init_managers();
  function _typeof18(obj) {
    "@babel/helpers - typeof";

    return _typeof18 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof18(obj);
  }
  function _classCallCheck15(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties15(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey16(descriptor.key), descriptor);
    }
  }
  function _createClass15(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties15(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties15(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey16(arg) {
    var key = _toPrimitive16(arg, "string");
    return _typeof18(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive16(input, hint) {
    if (_typeof18(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof18(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var INSIGN_PHASE = {
    GA_INIT_GT_TERMS: "PH_GA_INIT_GT_TERMS",
    PN_TERMS_ERROR_FROM_GA_INIT_GT: "PH_PN_TERMS_ERROR_FROM_GA_INIT_GT",
    IAC_TERMS_ERROR_FROM_GA_INIT_GT: "PH_IAC_TERMS_ERROR_FROM_GA_INIT_GT",
    GA_INIT_LC_TERMS: "PH_GA_INIT_LC_TERMS",
    PN_TERMS_CONSENT_FROM_GA_INIT_LC: "PH_PN_TERMS_CONSENT_FROM_GA_INIT_LC",
    IAC_TERMS_CONSENT_FROM_GA_INIT_LC: "PH_IAC_TERMS_CONSENT_FROM_GA_INIT_LC",
    GA_LOGIN_WT_TERMS: "PH_GA_LOGIN_WT_TERMS",
    IAC_TERMS_CONSENT_FROM_GA_LOGIN_WT: "PH_IAC_TERMS_CONSENT_FROM_GA_LOGIN_WT",
    SA_AL_NX_LOGIN: "PH_SA_AL_NX_LOGIN",
    INSIGN_SESSION_FAIL_FROM_SA_AL_NX_LOGIN: "PH_INSIGN_SESSION_FAIL_FROM_SA_AL_NX_LOGIN",
    PN_AL_ERR_GP: "PH_PN_AL_ERR_GP",
    PN_AL_ERR_GUID: "PH_PN_AL_ERR_GUID",
    PN_AL_AC_TERMS_TK: "PH_PN_AL_AC_TERMS_TK",
    PN_AL_SUCCESS_TERMS_TK: "PH_PN_AL_SUCCESS_TERMS_TK",
    IAC_TERMS_CONSENT_FROM_PN_AL_AC: "PH_IAC_TERMS_CONSENT_FROM_PN_AL_AC",
    IAC_TERMS_CONSENT_FROM_PN_AL_SUCCESS: "PH_IAC_TERMS_CONSENT_FROM_PN_AL_SUCCESS"
  };
  var InsignService = /* @__PURE__ */function () {
    function InsignService2() {
      _classCallCheck15(this, InsignService2);
      var phase = storeManager.getInsignPhase();
    }
    _createClass15(InsignService2, [{
      key: "init",
      value: function init2(gid) {
        this.gid = gid;
      }
    }, {
      key: "popInsignPhase",
      value: function popInsignPhase() {
        var phase = storeManager.getInsignPhase();
        storeManager.removeInsignPhase();
        if (this.verifyInsignPhase(phase)) {
          return phase;
        }
        return void 0;
      }
    }, {
      key: "verifyInsignPhase",
      value: function verifyInsignPhase(phase) {
        return Object.values(INSIGN_PHASE).includes(phase);
      }
    }, {
      key: "hasInsignPhase",
      value: function hasInsignPhase() {
        var phase = storeManager.getInsignPhase();
        return this.verifyInsignPhase(phase);
      }
      /** @param {INSIGN_PHASE} phase */
    }, {
      key: "setInsignPhase",
      value: function setInsignPhase(phase) {
        if (!Object.values(INSIGN_PHASE).includes(phase)) {
          throw new Error("Wrong implementation of Insign Phase");
        }
        storeManager.setInsignPhase(phase);
      }
    }, {
      key: "issueIasTicketByWebToken",
      value: function issueIasTicketByWebToken() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          _ref$gid = _ref.gid,
          gid = _ref$gid === void 0 ? this.gid : _ref$gid,
          _ref$webToken = _ref.webToken,
          webToken = _ref$webToken === void 0 ? storeManager.webToken : _ref$webToken;
        return _iasApi.issueTicketByWebToken({
          gid: gid,
          webToken: webToken
        });
      }
      /**
       * 우선 순위는 지정된 platform(krpc|jppc|etc), country(kr|jp|etc) 입니다.
       * @returns {string} (KRPC|JPPC|ARENA) URL
       */
    }, {
      key: "getNexonHomeUrlByPlatform",
      value: function getNexonHomeUrlByPlatform() {
        var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          pltf = _ref2.platform,
          countryParam = _ref2.country;
        var country = countryParam || storeManager.selectorCountry;
        var platform = pltf || storeManager.selectorPlatform;
        if (platform) {
          if (platform === PLATFORM.KRPC) return NEXON_HOME.KRPC;
          if (platform === PLATFORM.JPPC) return NEXON_HOME.JPPC;
          return NEXON_HOME.ARENA;
        }
        if (country) {
          if (country === "kr") return NEXON_HOME.KRPC;
          if (country === "jp") return NEXON_HOME.JPPC;
          return NEXON_HOME.ARENA;
        }
        return NEXON_HOME.KRPC;
      }
    }]);
    return InsignService2;
  }();
  var insignService = new InsignService();

  // lib/services/router.service.js
  init_managers();
  function _typeof19(obj) {
    "@babel/helpers - typeof";

    return _typeof19 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof19(obj);
  }
  function _classCallCheck16(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties16(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey17(descriptor.key), descriptor);
    }
  }
  function _createClass16(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties16(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties16(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey17(arg) {
    var key = _toPrimitive17(arg, "string");
    return _typeof19(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive17(input, hint) {
    if (_typeof19(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof19(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var ROUTES = {
    PLAYNOW: {
      LOGIN_SELECTOR: "/playnow/signin",
      TERMS: "/playnow/terms",
      CODE: "/playnow/code",
      LOGOUT: "/playnow/signout"
    },
    SIGNUP: "/signup",
    LOGIN: "/login",
    LOGOUT: "/logout",
    TOY_TERMS: "/consent/terms",
    SETTING: {
      ACCOUNT: "/setting/account"
    }
  };
  var RouterService = /* @__PURE__ */function () {
    function RouterService2() {
      _classCallCheck16(this, RouterService2);
    }
    _createClass16(RouterService2, [{
      key: "gotoSignUp",
      value: function gotoSignUp(_ref) {
        var gid = _ref.gid,
          _ref$redirectUri = _ref.redirectUri,
          redirectUri = _ref$redirectUri === void 0 ? window.location.href : _ref$redirectUri;
        var url = this._getUrl(ROUTES.SIGNUP, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoLogin",
      value: function gotoLogin(_ref2) {
        var gid = _ref2.gid,
          _ref2$redirectUri = _ref2.redirectUri,
          redirectUri = _ref2$redirectUri === void 0 ? window.location.href : _ref2$redirectUri;
        var url = this._getUrl(ROUTES.LOGIN, {
          use_game_token: true,
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoPNLoginSelector",
      value: function gotoPNLoginSelector(_ref3) {
        var gid = _ref3.gid,
          _ref3$redirectUri = _ref3.redirectUri,
          redirectUri = _ref3$redirectUri === void 0 ? window.location.href : _ref3$redirectUri;
        var url = this._getUrl(ROUTES.PLAYNOW.LOGIN_SELECTOR, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoLogout",
      value: function gotoLogout(_ref4) {
        var gid = _ref4.gid,
          _ref4$redirectUri = _ref4.redirectUri,
          redirectUri = _ref4$redirectUri === void 0 ? window.location.href : _ref4$redirectUri;
        var url = this._getUrl(ROUTES.LOGOUT, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoPNLogout",
      value: function gotoPNLogout(_ref5) {
        var gid = _ref5.gid,
          _ref5$redirectUri = _ref5.redirectUri,
          redirectUri = _ref5$redirectUri === void 0 ? window.location.href : _ref5$redirectUri;
        var url = this._getUrl(ROUTES.PLAYNOW.LOGOUT, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoPNTerms",
      value: function gotoPNTerms(_ref6) {
        var gid = _ref6.gid,
          guid = _ref6.guid,
          ticket = _ref6.ticket,
          _ref6$redirectUri = _ref6.redirectUri,
          redirectUri = _ref6$redirectUri === void 0 ? window.location.href : _ref6$redirectUri;
        var query = {
          gid: gid,
          redirect_uri: redirectUri
        };
        if (guid) query.guid = guid;
        if (ticket) query.ticket = ticket;
        var url = this._getUrl(ROUTES.PLAYNOW.TERMS, query);
        this.moveToGw(url);
      }
    }, {
      key: "gotoToyTerms",
      value: function gotoToyTerms(_ref7) {
        var gid = _ref7.gid,
          _ref7$redirectUri = _ref7.redirectUri,
          redirectUri = _ref7$redirectUri === void 0 ? window.location.href : _ref7$redirectUri;
        var url = this._getUrl(ROUTES.TOY_TERMS, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "gotoPNCode",
      value: function gotoPNCode(_ref8) {
        var gid = _ref8.gid,
          _ref8$redirectUri = _ref8.redirectUri,
          redirectUri = _ref8$redirectUri === void 0 ? window.location.href : _ref8$redirectUri;
        var url = this._getUrl(ROUTES.PLAYNOW.CODE, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "showAccountSettings",
      value: function showAccountSettings(_ref9) {
        var gid = _ref9.gid,
          _ref9$redirectUri = _ref9.redirectUri,
          redirectUri = _ref9$redirectUri === void 0 ? window.location.href : _ref9$redirectUri;
        var url = this._getUrl(ROUTES.SETTING.ACCOUNT, {
          gid: gid,
          redirect_uri: redirectUri
        });
        this.moveToGw(url);
      }
    }, {
      key: "_getUrl",
      value: function _getUrl(route, queryObject) {
        var params = new URLSearchParams(queryObject);
        var query = Array.from(params.keys()).length ? "?".concat(params.toString()) : "";
        return "".concat(environmentManager.apiUrl.INSIGN_BASE_URL).concat(route).concat(query);
      }
    }, {
      key: "moveToGw",
      value: function moveToGw(url) {
        window.location.href = url;
      }
    }]);
    return RouterService2;
  }();
  var routerService = new RouterService();

  // lib/services/user.service.js
  init_core();
  init_constants();
  function _typeof20(obj) {
    "@babel/helpers - typeof";

    return _typeof20 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof20(obj);
  }
  function _regeneratorRuntime9() {
    "use strict";

    _regeneratorRuntime9 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof20(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof20(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep9(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator9(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep9(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep9(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck17(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties17(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey18(descriptor.key), descriptor);
    }
  }
  function _createClass17(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties17(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties17(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey18(arg) {
    var key = _toPrimitive18(arg, "string");
    return _typeof20(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive18(input, hint) {
    if (_typeof20(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof20(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var _require2 = (init_apis(), __toCommonJS(apis_exports));
  var boltApi2 = _require2.boltApi;
  var UserService = /* @__PURE__ */function () {
    function UserService2() {
      _classCallCheck17(this, UserService2);
    }
    _createClass17(UserService2, [{
      key: "init",
      value: function init2(gid) {
        this.gid = gid;
      }
      /**
       *
       * @param {string} ticket - ias-ticket
       * @returns
       */
    }, {
      key: "recoverUser",
      value: function () {
        var _recoverUser = _asyncToGenerator9( /* @__PURE__ */_regeneratorRuntime9().mark(function _callee(ticket, _ref) {
          var _ref$gid, gid, deviceId, uuid;
          return _regeneratorRuntime9().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _ref$gid = _ref.gid, gid = _ref$gid === void 0 ? this.gid : _ref$gid, deviceId = _ref.uuid;
                _context.t0 = deviceId;
                if (_context.t0) {
                  _context.next = 6;
                  break;
                }
                _context.next = 5;
                return persistenceService.syncedUuid();
              case 5:
                _context.t0 = _context.sent;
              case 6:
                uuid = _context.t0;
                return _context.abrupt("return", boltApi2.recoverUser({
                  ticket: ticket,
                  gid: gid,
                  uuid: uuid
                }));
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function recoverUser(_x, _x2) {
          return _recoverUser.apply(this, arguments);
        }
        return recoverUser;
      }()
    }, {
      key: "logoutUser",
      value: function () {
        var _logoutUser = _asyncToGenerator9( /* @__PURE__ */_regeneratorRuntime9().mark(function _callee2() {
          var gid,
            _yield$gameTokenServi,
            gameToken,
            guid,
            _args2 = arguments;
          return _regeneratorRuntime9().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                gid = _args2.length > 0 && _args2[0] !== void 0 ? _args2[0] : this.gid;
                _context2.next = 3;
                return gameTokenService.getVerifiedGameTokenInfo(gid);
              case 3:
                _yield$gameTokenServi = _context2.sent;
                gameToken = _yield$gameTokenServi.gameToken;
                guid = _yield$gameTokenServi.guid;
                _context2.t0 = boltApi2;
                _context2.t1 = gid;
                _context2.t2 = guid;
                _context2.t3 = gameToken;
                _context2.next = 12;
                return persistenceService.syncedUuid();
              case 12:
                _context2.t4 = _context2.sent;
                _context2.t5 = {
                  gid: _context2.t1,
                  guid: _context2.t2,
                  gameToken: _context2.t3,
                  uuid: _context2.t4
                };
                return _context2.abrupt("return", _context2.t0.logoutService.call(_context2.t0, _context2.t5));
              case 15:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function logoutUser() {
          return _logoutUser.apply(this, arguments);
        }
        return logoutUser;
      }()
      /**
       * 현재 로그인된 사용자의 게임 토큰을 검증하여 사용자 정보를 반환하는 퍼블릭 메서드입니다.
       *
       * - 검증 API 호출이 성공하면 응답을 10초 동안 캐싱하여 불필요한 중복 호출을 방지합니다.
       * - 실패 응답의 경우 error 속성에 verifyGameToken 메서드에서 전달 받은 에러 코드가 담깁니다.
       * - 성공 응답 값의 data 속성에는 사용자 정보가 담깁니다.
       *   -> guid, uid, platformType, platformUserId, npaCode, gameToken
       *   -> (참고) Mobile/PC/Console 등 타 GS SDK에서 제공하는 getUserInfo 메서드와 유사하게 구성되어 있습니다.
       */
    }, {
      key: "getUserInfo",
      value: function () {
        var _getUserInfo = _asyncToGenerator9( /* @__PURE__ */_regeneratorRuntime9().mark(function _callee3() {
          var functionName, responseBuilder, gameToken, verifyResponse, _verifyResponse$error, _verifyResponse$data, guid, uid, platformType, platformUserId, npaCode, userInfo;
          return _regeneratorRuntime9().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                functionName = "getUserInfo";
                responseBuilder = function responseBuilder2() {
                  var success = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                  return new _ResponseBuilder(success, {
                    functionName: functionName
                  });
                };
                _context3.next = 4;
                return gameTokenService.getVerifiedGameToken();
              case 4:
                gameToken = _context3.sent;
                if (gameToken) {
                  _context3.next = 7;
                  break;
                }
                return _context3.abrupt("return", responseBuilder(false).error(error_code_enum_default.GAME_AUTH.SDK.INVALID_GAME_TOKEN).build());
              case 7:
                _context3.next = 9;
                return gameTokenService.verifyGameToken(gameToken);
              case 9:
                verifyResponse = _context3.sent;
                if (verifyResponse.success) {
                  _context3.next = 12;
                  break;
                }
                return _context3.abrupt("return", responseBuilder(false).error(verifyResponse.error).errorRawResponseData((_verifyResponse$error = verifyResponse.error) === null || _verifyResponse$error === void 0 ? void 0 : _verifyResponse$error.rawResponseData).build());
              case 12:
                _verifyResponse$data = verifyResponse.data, guid = _verifyResponse$data.guid, uid = _verifyResponse$data.uid, platformType = _verifyResponse$data.platformType, platformUserId = _verifyResponse$data.platformUserId, npaCode = _verifyResponse$data.npaCode;
                userInfo = {
                  guid: guid,
                  uid: uid,
                  platformType: platformType,
                  platformUserId: platformUserId,
                  npaCode: npaCode,
                  gameToken: gameToken
                };
                return _context3.abrupt("return", responseBuilder(true).data(userInfo).build());
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function getUserInfo() {
          return _getUserInfo.apply(this, arguments);
        }
        return getUserInfo;
      }()
    }]);
    return UserService2;
  }();
  var userService = new UserService();

  // lib/web-game-auth/insign-game-auth.class.js
  init_managers();

  // lib/web-game-auth/web-game-auth.class.js
  init_apis();
  init_core();
  init_managers();
  init_constants();

  // lib/modal/alert-modal.class.js
  function _typeof21(obj) {
    "@babel/helpers - typeof";

    return _typeof21 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof21(obj);
  }
  function _classCallCheck18(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties18(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey19(descriptor.key), descriptor);
    }
  }
  function _createClass18(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties18(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties18(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey19(arg) {
    var key = _toPrimitive19(arg, "string");
    return _typeof21(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive19(input, hint) {
    if (_typeof21(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof21(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var instance;
  var AlertModal = /* @__PURE__ */function () {
    function AlertModal2() {
      _classCallCheck18(this, AlertModal2);
    }
    _createClass18(AlertModal2, [{
      key: "title",
      get: function get() {
        return this._title;
      },
      set: function set(title) {
        this._title = title;
        this._renewTexts();
      }
    }, {
      key: "message",
      get: function get() {
        return this._message;
      },
      set: function set(htmlMessage) {
        this._message = htmlMessage;
        this._renewTexts();
      }
    }, {
      key: "_renewTexts",
      value: function _renewTexts() {
        if (!this._modal) return;
        this._modal.modalHeaderDiv.innerText = this.title;
        this._modal.modalBodyDiv.innerHTML = this.message;
      }
    }, {
      key: "_createModal",
      value: function _createModal() {
        var _this = this;
        var style = document.createElement("style");
        style.textContent = "\n      ._inface_game-auth_container {\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0, 0, 0, .8);\n        position: absolute;\n        top: 0;\n        left: 0;\n        font-family: 'Noto Sans KR';\n        font-weight: 400;\n        z-index: 999;\n        display: block;\n      }\n      ._inface_game-auth_modal__container {\n        width: 320px;\n        height: 276px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: inline-flex;\n        flex-direction: column;\n        align-items: center;\n        box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);\n        background: #FFFFFF;\n        border-radius: 4px;\n\n        @media (min-width: 1024px) {\n          width: 400px; \n          height: 262px;\n        }\n      }\n      ._inface_game-auth_modal__header {\n        color: #17191C;\n        display: flex;\n        width: 100%;\n        height: 80px;\n        padding: 32px 28px 20px 28px;\n        justify-content: center;\n        align-items: flex-start;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 28px;\n        letter-spacing: -0.4px;\n\n        @media (min-width: 1024px) {\n          height: 82px;\n          font-size: 20px;\n          line-height: 30px; /* 150% */\n          letter-spacing: -0.43px;\n        }\n      }\n      ._inface_game-auth_modal__body {\n        color: #51555D;\n        display: flex;\n        \n        text-align: center;\n        width: 100%;\n        height: 88px;\n        font-size: 14px;\n        line-height: 22px; /* 157.143% */\n        letter-spacing: -0.3px;\n        padding: 0 28px;\n\n        @media (min-width: 1024px) {\n          height: 72px;\n          font-size: 16px;\n          line-height: 24px;\n          letter-spacing: -0.35px;\n        }\n      }\n      ._inface_game-auth_modal__footer {\n        width: 100%;\n        height: 108px;\n      }\n      ._inface_game-auth_modal__button {\n        width: 264px;\n        height: 48px;\n        margin: 32px 28px 28px 28px;\n        background: #17191C;\n        color: #FFFFFF;\n        outline: none;\n        border: 0;\n        border-radius: 4px;\n        font-size: 16px;\n        padding: 0;\n\n        @media (min-width: 1024px) {\n          width: 344px;\n        }\n      }\n      ._inface_game-auth_modal__button:hover, ._inface_game-auth_modal__button:active {\n        background: #3D4148;\n      }\n    ";
        document.getElementsByTagName("head")[0].appendChild(style);
        var containerSection = document.createElement("section");
        containerSection.classList.add("_inface_game-auth_container");
        var modalDiv = document.createElement("div");
        modalDiv.classList.add("_inface_game-auth_modal__container");
        var modalHeaderDiv = document.createElement("div");
        modalHeaderDiv.classList.add("_inface_game-auth_modal__header");
        modalHeaderDiv.innerText = this.title || "";
        var modalBodyDiv = document.createElement("div");
        modalBodyDiv.classList.add("_inface_game-auth_modal__body");
        modalBodyDiv.innerHTML = this.message || "";
        var modalFooterDiv = document.createElement("div");
        modalFooterDiv.classList.add("_inface_game-auth_modal__footer");
        var button = document.createElement("button");
        button.classList.add("_inface_game-auth_modal__button");
        button.innerText = "\uD655\uC778";
        button.addEventListener("click", function () {
          _this.hide();
        });
        modalFooterDiv.appendChild(button);
        modalDiv.appendChild(modalHeaderDiv);
        modalDiv.appendChild(modalBodyDiv);
        modalDiv.appendChild(modalFooterDiv);
        containerSection.appendChild(modalDiv);
        var body = document.getElementsByTagName("body")[0];
        this._originalValues = {
          bodyStyle: body.style.position
        };
        body.style.position = "relative";
        body.append(containerSection);
        this._modal = {
          containerSection: containerSection,
          modalHeaderDiv: modalHeaderDiv,
          modalBodyDiv: modalBodyDiv,
          modalFooterDiv: modalFooterDiv
        };
      }
    }, {
      key: "show",
      value: function show() {
        if (!this._modal) this._createModal();
        this._modal.containerSection.style.display = "block";
      }
    }, {
      key: "hide",
      value: function hide() {
        this._modal.containerSection.style.display = "none";
      }
    }], [{
      key: "instance",
      get: function get() {
        if (instance) return instance;
        instance = new AlertModal2();
        return instance;
      }
    }]);
    return AlertModal2;
  }();

  // lib/web-game-auth/web-game-auth.class.js
  function _typeof22(obj) {
    "@babel/helpers - typeof";

    return _typeof22 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof22(obj);
  }
  function _regeneratorRuntime10() {
    "use strict";

    _regeneratorRuntime10 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof22(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof22(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep10(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator10(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep10(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep10(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck19(instance2, Constructor) {
    if (!(instance2 instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties19(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey20(descriptor.key), descriptor);
    }
  }
  function _createClass19(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties19(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties19(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey20(arg) {
    var key = _toPrimitive20(arg, "string");
    return _typeof22(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive20(input, hint) {
    if (_typeof22(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (_typeof22(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _classPrivateMethodInitSpec(obj, privateSet) {
    _checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
  }
  function _checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
      throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
  }
  function _classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
      throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
  }
  var MODULE_NAME = "web-game-auth";
  var _validateWorkingEnvironment = /* @__PURE__ */new WeakSet();
  var WebGameAuth = /* @__PURE__ */function () {
    function WebGameAuth2() {
      var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
        gid = _ref.gid,
        env = _ref.env,
        locale = _ref.locale,
        country = _ref.country;
      _classCallCheck19(this, WebGameAuth2);
      _classPrivateMethodInitSpec(this, _validateWorkingEnvironment);
      this._infaceMetas = InfaceService.instance.infaceMetas;
      InfaceService.instance.setModuleName(MODULE_NAME);
      this._changeStatus(SDK_STATUS.PREPARING);
      InfaceService.instance.addEventListener(INFACE_EVENT_TYPE.TOY_WEB_SDK_MODULE, this._onInfaceModuleEventListener.bind(this));
      this.setInsignEnvironment({
        gid: gid,
        env: env,
        locale: locale,
        country: country
      });
      persistenceService.syncedUuid({
        initializePhase: true
      });
    }
    _createClass19(WebGameAuth2, [{
      key: "saveGameTokenInfo",
      value: function () {
        var _saveGameTokenInfo = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee(guid, gameToken) {
          var verifyGTResponse, _verifyGTResponse$dat, gidFromServer, guidFromServer, eventData;
          return _regeneratorRuntime10().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.gid || !guid || !gameToken)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", new _ResponseBuilder(false, {
                  functionName: "saveGameTokenInfo"
                }).error(error_code_enum_default.GAME_AUTH.SDK.INVALID_PARAMETER).build());
              case 2:
                _context.next = 4;
                return gameTokenService.verifyGameToken(gameToken);
              case 4:
                verifyGTResponse = _context.sent;
                if (verifyGTResponse.success) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", new _ResponseBuilder(false, {
                  functionName: "saveGameTokenInfo"
                }).error(verifyGTResponse.error).errorRawResponseData(verifyGTResponse.error.rawResponseData).build());
              case 7:
                _verifyGTResponse$dat = verifyGTResponse.data, gidFromServer = _verifyGTResponse$dat.gid, guidFromServer = _verifyGTResponse$dat.guid;
                if (!("".concat(gidFromServer) !== "".concat(this.gid) || "".concat(guidFromServer) !== "".concat(guid))) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", new _ResponseBuilder(false, {
                  functionName: "saveGameTokenInfo"
                }).error(error_code_enum_default.GAME_AUTH.SDK.INVALID_PARAMETER).build());
              case 10:
                storeManager.putGameTokenInfo(this.gid, guid, gameToken);
                eventData = {
                  type: SDK_EVENT_TYPE.AUTH_USER,
                  data: {
                    status: AUTH_USER_STATUS.LOGIN,
                    gid: this.gid,
                    gameToken: gameToken
                  }
                };
                InfaceService.instance.sendSdkEvent({
                  eventData: eventData
                });
                return _context.abrupt("return", new _ResponseBuilder(true, {
                  functionName: "saveGameTokenInfo"
                }).data({
                  gameToken: gameToken,
                  guid: guid,
                  gid: this.gid
                }).build());
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function saveGameTokenInfo(_x, _x2) {
          return _saveGameTokenInfo.apply(this, arguments);
        }
        return saveGameTokenInfo;
      }()
    }, {
      key: "getUserInfo",
      value: function () {
        var _getUserInfo = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee2() {
          return _regeneratorRuntime10().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Promise.resolve(userService.getUserInfo()));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function getUserInfo() {
          return _getUserInfo.apply(this, arguments);
        }
        return getUserInfo;
      }()
    }, {
      key: "isLogin",
      get: function get() {
        var _this = this;
        return new Promise( /* @__PURE__ */function () {
          var _ref2 = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee3(resolve) {
            return _regeneratorRuntime10().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.t0 = resolve;
                  _context3.next = 3;
                  return _this.gameToken;
                case 3:
                  _context3.t1 = !!_context3.sent;
                  (0, _context3.t0)(_context3.t1);
                case 5:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "gid",
      get: function get() {
        return this._gid;
      }
    }, {
      key: "env",
      get: function get() {
        return this._env;
      }
    }, {
      key: "gameToken",
      get: function get() {
        return Promise.resolve(gameTokenService.getVerifiedGameToken());
      }
    }, {
      key: "guid",
      get: function get() {
        return Promise.resolve(gameTokenService.getValidGuid());
      }
    }, {
      key: "webToken",
      get: function get() {
        return storeManager.webToken;
      },
      set: function set(value) {
        storeManager.webToken = value;
      }
      /** @returns {{ type: ACCOUNT_TYPE }} */
    }, {
      key: "accountType",
      get: function get() {
        if (this.memType) {
          var type = this.memType === _BOLT_ENUM.MEM_TYPE.PLAYNOW ? ACCOUNT_TYPE.PLAYNOW : ACCOUNT_TYPE.NX;
          return {
            type: type
          };
        }
        return {};
      }
    }, {
      key: "localCredential",
      get: function get() {
        return storeManager.getLocalCredentialInfo(this.gid).localCredentialID;
      }
      /**
       *  Web Game Auth 를 초기화 합니다.
       * Game Token, Local Credential 을 체크해서 로그인 유지 또는 자동 로그인을 수행 합니다.
       */
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee4() {
          var _ref3,
            gid,
            env,
            _args4 = arguments;
          return _regeneratorRuntime10().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _ref3 = _args4.length > 0 && _args4[0] !== void 0 ? _args4[0] : {}, gid = _ref3.gid, env = _ref3.env;
                if (gid) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return", console.warn("game-auth won't work, gid is required"));
              case 3:
                if (_classPrivateMethodGet(this, _validateWorkingEnvironment, _validateWorkingEnvironment2).call(this)) {
                  _context4.next = 5;
                  break;
                }
                return _context4.abrupt("return");
              case 5:
                storeManager.checkCrossSiteLCForSignoutPhase(gid);
                storeManager.checkCrossSiteLCForSigninPhase(gid);
                this.setInsignEnvironment({
                  gid: gid,
                  env: env
                });
                _context4.next = 10;
                return this._initInPhaseGameToken();
              case 10:
                if (_context4.sent) {
                  _context4.next = 13;
                  break;
                }
                _context4.next = 13;
                return this._initInPhaseLocalCredential();
              case 13:
                _context4.next = 15;
                return this._changeStatus(SDK_STATUS.INITIALIZED);
              case 15:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function init2() {
          return _init.apply(this, arguments);
        }
        return init2;
      }()
    }, {
      key: "gotoSignUp",
      value: function gotoSignUp() {
        routerService.gotoSignUp({
          gid: this.gid
        });
      }
    }, {
      key: "gotoLogin",
      value: function gotoLogin() {
        var _ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          pn = _ref4.playnow;
        var playnow = pn || environmentService.playnow;
        if (playnow) {
          routerService.gotoPNLoginSelector({
            gid: this.gid
          });
        } else {
          routerService.gotoLogin({
            gid: this.gid
          });
        }
      }
    }, {
      key: "gotoLogout",
      value: function gotoLogout() {
        if (this.accountType.type === ACCOUNT_TYPE.PLAYNOW) {
          routerService.gotoPNLogout({
            gid: this.gid
          });
        } else {
          routerService.gotoLogout({
            gid: this.gid
          });
        }
      }
    }, {
      key: "showPlayNowCode",
      value: function showPlayNowCode() {
        var _ref5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          redirectUri = _ref5.redirectUri;
        routerService.gotoPNCode({
          gid: this.gid,
          redirectUri: redirectUri
        });
      }
    }, {
      key: "showAccountSettings",
      value: function showAccountSettings() {
        var _ref6 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          redirectUri = _ref6.redirectUri;
        routerService.showAccountSettings({
          gid: this.gid,
          redirectUri: redirectUri
        });
      }
    }, {
      key: "issueLaunchingToken",
      value: function issueLaunchingToken() {
        return gameTokenService.issueWebTokenByGameToken();
      }
      // #endregion
      // #region INSIGN 공개 (web-game-auth Library)
      /** @returns {SDK_STATUS} */
    }, {
      key: "status",
      get: function get() {
        return this._status;
      }
      /** @returns {string} */
    }, {
      key: "playNowUid",
      get: function get() {
        return storeManager.getLocalCredentialInfo(this.gid).playNowUserID;
      }
      /**
       *  memory 에 저장된 INSIGN Phase 를 반환 합니다. (없으면 popInsignPhase 후 반환)
       * 일반 getter 와 달리 pop 동작을 해서 주의 차원에서 current prefix 를 추가했습니다.
       *
       * @returns {INSIGN_PHASE}
       */
    }, {
      key: "currentInsignPhase",
      get: function get() {
        if (typeof this._insignPhase === "undefined") this._insignPhase = this.popInsignPhase();
        return this._insignPhase;
      }
      /**
       * Session Storage 에 저장된 INSIGN Phase 를 삭제한 후 memory 에 저장한 후 반환 합니다.
       * @returns {INSIGN_PHASE}
       */
    }, {
      key: "popInsignPhase",
      value: function popInsignPhase() {
        this._insignPhase = insignService.popInsignPhase();
        return this._insignPhase;
      }
      /** @param {INSIGN_PHASE} phase */
    }, {
      key: "setInsignPhase",
      value: function setInsignPhase(phase) {
        insignService.setInsignPhase(phase);
      }
      /** @returns {boolean} */
    }, {
      key: "hasInsignPhase",
      value: function hasInsignPhase() {
        return insignService.hasInsignPhase();
      }
      /**
       *  게임토큰을 발급하고 쿠키에 저장합니다.
       *
       * @param {object} params
       * @param {string} params.guid
       * @param {string} params.ticket ias-ticket
       * @param {string} params.locale language_LOCATION
       * @param {number|string} params.gid
       * @returns {InsignResponse}
       */
    }, {
      key: "issueGameToken",
      value: function () {
        var _issueGameToken = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee5(guid, ticket) {
          var _ref7,
            locale,
            gid,
            _args5 = arguments;
          return _regeneratorRuntime10().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _ref7 = _args5.length > 2 && _args5[2] !== void 0 ? _args5[2] : {}, locale = _ref7.locale, gid = _ref7.gid;
                return _context5.abrupt("return", gameTokenService.issueGameToken({
                  gid: gid || this.gid,
                  guid: guid,
                  ticket: ticket,
                  locale: locale
                }));
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function issueGameToken(_x4, _x5) {
          return _issueGameToken.apply(this, arguments);
        }
        return issueGameToken;
      }()
      // #endregion
      // #region Class 내부 business Logic
      /**
       * @inner
       * @returns {boolean} 초기화 과정 종료 시 true
       */
    }, {
      key: "_initInPhaseGameToken",
      value: function () {
        var _initInPhaseGameToken2 = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee6() {
          var gameToken, _yield$toyTermsServic, success, data, memType, termsAgree;
          return _regeneratorRuntime10().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.gameToken;
              case 2:
                gameToken = _context6.sent;
                if (!gameToken) {
                  _context6.next = 17;
                  break;
                }
                _context6.next = 6;
                return toyTermsService.getTermsByGameToken(this.gid);
              case 6:
                _yield$toyTermsServic = _context6.sent;
                success = _yield$toyTermsServic.success;
                data = _yield$toyTermsServic.data;
                if (!success) {
                  _context6.next = 17;
                  break;
                }
                memType = data.memType, termsAgree = data.termsAgree;
                this.memType = memType;
                if ((termsAgree || []).length) {
                  _context6.next = 14;
                  break;
                }
                return _context6.abrupt("return", true);
              case 14:
                this.setInsignPhase(INSIGN_PHASE.GA_INIT_GT_TERMS);
                if (memType === _BOLT_ENUM.MEM_TYPE.PLAYNOW) {
                  routerService.gotoPNTerms({
                    gid: this.gid
                  });
                } else {
                  routerService.gotoToyTerms({
                    gid: this.gid
                  });
                }
                return _context6.abrupt("return", true);
              case 17:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function _initInPhaseGameToken() {
          return _initInPhaseGameToken2.apply(this, arguments);
        }
        return _initInPhaseGameToken;
      }()
    }, {
      key: "_initInPhaseLocalCredential",
      value: function () {
        var _initInPhaseLocalCredential2 = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee7() {
          var _yield$toyTermsServic2, success, data, error, guid, termsAgree, ticket, result;
          return _regeneratorRuntime10().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.localCredential) {
                  _context7.next = 22;
                  break;
                }
                _context7.next = 3;
                return toyTermsService.getTermsWithLocalCredential(this.gid);
              case 3:
                _yield$toyTermsServic2 = _context7.sent;
                success = _yield$toyTermsServic2.success;
                data = _yield$toyTermsServic2.data;
                error = _yield$toyTermsServic2.error;
                if (!success) {
                  _context7.next = 21;
                  break;
                }
                guid = data.guid, termsAgree = data.termsAgree, ticket = data.ticket;
                if ((termsAgree || []).length) {
                  _context7.next = 18;
                  break;
                }
                _context7.next = 12;
                return this.issueGameToken(guid, ticket);
              case 12:
                result = _context7.sent;
                if (result.success) {
                  _context7.next = 16;
                  break;
                }
                console.error("[WGA::init] LC \uC790\uB3D9 \uB85C\uADF8\uC778 \uC911 GT \uBC1C\uAE09 \uC2E4\uD328 (\uBE44\uB85C\uADF8\uC778 \uC0C1\uD0DC)", result);
                return _context7.abrupt("return");
              case 16:
                this.memType = _BOLT_ENUM.MEM_TYPE.PLAYNOW;
                return _context7.abrupt("return");
              case 18:
                this.setInsignPhase(INSIGN_PHASE.GA_INIT_LC_TERMS);
                routerService.gotoPNTerms({
                  guid: guid,
                  ticket: ticket,
                  gid: this.gid
                });
                return _context7.abrupt("return");
              case 21:
                this._showModalIfInCase(error);
              case 22:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function _initInPhaseLocalCredential() {
          return _initInPhaseLocalCredential2.apply(this, arguments);
        }
        return _initInPhaseLocalCredential;
      }()
    }, {
      key: "_showModalIfInCase",
      value: function _showModalIfInCase() {
        var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _ref8 = error.rawResponseData || {},
          errorCode = _ref8.errorCode,
          errorText = _ref8.errorText;
        var NSRRS = [1204, 1206];
        if (NSRRS.indexOf(errorCode) !== -1) {
          console.warn("\uC81C\uC7AC \uC5D0\uB7EC \uBC1C\uC0DD");
          storeManager.removeLocalCredentialInfo(this.gid);
          AlertModal.instance.title = "";
          AlertModal.instance.message = "".concat(errorText, "(").concat(errorCode, ")");
          AlertModal.instance.show();
        }
      }
    }, {
      key: "_changeStatus",
      value: function () {
        var _changeStatus2 = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee8(status) {
          return _regeneratorRuntime10().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                this._status = status;
                _context8.t0 = InfaceService.instance;
                _context8.t1 = status;
                _context8.next = 5;
                return this.gameToken;
              case 5:
                _context8.t2 = _context8.sent;
                _context8.t3 = {
                  gameToken: _context8.t2
                };
                _context8.t4 = {
                  status: _context8.t1,
                  additionalData: _context8.t3
                };
                _context8.t0.sendStatusChangeEvent.call(_context8.t0, _context8.t4);
              case 9:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function _changeStatus(_x6) {
          return _changeStatus2.apply(this, arguments);
        }
        return _changeStatus;
      }()
    }, {
      key: "setInsignEnvironment",
      value: function setInsignEnvironment() {
        var _ref9 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          gid = _ref9.gid,
          env = _ref9.env,
          locale = _ref9.locale,
          country = _ref9.country;
        this._env = environmentService.setEnvironment({
          gid: gid,
          env: env,
          locale: locale,
          country: country
        });
        this._gid = gid;
        userService.init(gid);
        gameTokenService.init(gid);
        toyTermsService.init(gid);
      }
      /** @param {import('../services/inface.service').ToyWebSdkEvent} */
    }, {
      key: "_onInfaceModuleEventListener",
      value: function () {
        var _onInfaceModuleEventListener2 = _asyncToGenerator10( /* @__PURE__ */_regeneratorRuntime10().mark(function _callee9() {
          var _ref10,
            moduleName,
            eventData,
            _args9 = arguments;
          return _regeneratorRuntime10().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _ref10 = _args9.length > 0 && _args9[0] !== void 0 ? _args9[0] : {}, moduleName = _ref10.moduleName, eventData = _ref10.eventData;
                if (!(moduleName === MODULE_NAME)) {
                  _context9.next = 3;
                  break;
                }
                return _context9.abrupt("return");
              case 3:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        function _onInfaceModuleEventListener() {
          return _onInfaceModuleEventListener2.apply(this, arguments);
        }
        return _onInfaceModuleEventListener;
      }()
      // #endregion
    }]);
    return WebGameAuth2;
  }();
  function _validateWorkingEnvironment2() {
    try {
      var infaceMetas = InfaceService.instance.infaceMetas;
      var gameAuth = infaceMetas["game-auth"];
      if (!gameAuth) {
        if (["2037", "2038", "2039"].includes(this.gid)) {
          gameTokenService.expireGameToken(this.gid);
        }
        return false;
      }
      return true;
    } catch (e) {
      console.error("[WGA::#validateWorkingEnvironment] Error: ".concat(e.message));
      return false;
    }
  }

  // lib/web-game-auth-sdk-browser.js
  function _regeneratorRuntime11() {
    "use strict";

    _regeneratorRuntime11 = function _regeneratorRuntime12() {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self2, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == _typeof23(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value2) {
            invoke("next", value2, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self2, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return {
            value: void 0,
            done: true
          };
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self2, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (void 0 === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable || "" === iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next2() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next2.value = iterable[i], next2.done = false, next2;
              return next2.value = void 0, next2.done = true, next2;
            };
          return next.next = next;
        }
      }
      throw new TypeError(_typeof23(iterable) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key2 = keys.pop();
          if (key2 in object) return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep11(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator11(fn) {
    return function () {
      var self2 = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self2, args);
        function _next(value) {
          asyncGeneratorStep11(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep11(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _typeof23(obj) {
    "@babel/helpers - typeof";

    return _typeof23 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj2) {
      return typeof obj2;
    } : function (obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof23(obj);
  }
  function isBrowser() {
    return (typeof window === "undefined" ? "undefined" : _typeof23(window)) === "object" && window.HTMLBodyElement;
  }
  function initialize() {
    if (!isBrowser()) return;
    var infaceMetas = InfaceService.instance.infaceMetas;
    var gid = infaceMetas.v2[INFACE_META_NAME.INFACE_GID];
    var env = infaceMetas.v2[INFACE_META_NAME.INFACE_ENV] || "live";
    if (!gid) {
      return;
    }
    window.addEventListener("load", /* @__PURE__ */_asyncToGenerator11( /* @__PURE__ */_regeneratorRuntime11().mark(function _callee() {
      return _regeneratorRuntime11().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return window.inface.gameAuth.init({
              gid: gid,
              env: env
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var instance2 = new WebGameAuth({
      gid: gid,
      env: env
    });
    window.inface = window.inface || {};
    window.inface.gameAuth = createSdkApis(instance2);
  }
  initialize();
})();
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
/*! Bundled license information:

js-cookie/dist/js.cookie.mjs:
  (*! js-cookie v3.0.5 | MIT *)
*/